// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/select_arow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/ongoing.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/sold.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.AttendeeCustomTable_dashboard__ar5py {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  overflow-y: auto;
  padding-right: 0px;
}

.AttendeeCustomTable_dashboardContain__9Ea-6 {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.AttendeeCustomTable_bodythemedark__aBYIU .AttendeeCustomTable_dashboardContain__9Ea-6,
.AttendeeCustomTable_bodythemedark__aBYIU .AttendeeCustomTable_dashboard__ar5py,
.AttendeeCustomTable_bodythemedark__aBYIU .AttendeeCustomTable_cont2__vnuPv {
  background-Color: #0f1824;
}

.AttendeeCustomTable_top_header__fPV4a .AttendeeCustomTable_top_header_inner__7ErW4 {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.AttendeeCustomTable_cont2__vnuPv {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  /*height: calc(100vh - 160px);*/
  height: 100%;
  min-height: auto !important;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.AttendeeCustomTable_subLink__zGuKZ svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.AttendeeCustomTable_cst_vendr__odxfK input {
  min-height: 35px !important;
}

.AttendeeCustomTable_cst_vendr__odxfK .AttendeeCustomTable_form-control__zbaGf {
  background-color: #f5f6fa;
  border: none;
}

.AttendeeCustomTable_footer__2XRLu {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.AttendeeCustomTable_bodythemelight__Fycx\\+ {
  background-color: #fff;
  padding-top: 90px;
}

.AttendeeCustomTable_bodythemedark__aBYIU {
  background-color: #132337;
  padding-top: 90px;
}

.AttendeeCustomTable_bodythemeNew__IaYc1 {
  background-color: #f5f6fa;
}

/* 
Header Navbar Theme
*/
.AttendeeCustomTable_headerthemelight__Eyjk7 {
  background-color: #fff;
}

.AttendeeCustomTable_headerthemedark__rrIXM {
  background-color: #132337;
}

.AttendeeCustomTable_top_header__fPV4a {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 2;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.AttendeeCustomTable_menuthemelight__wQ\\+6e {
  background-color: #f5f6fa;
}

.AttendeeCustomTable_menuthemedark__\\+bzgb {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.AttendeeCustomTable_menulinklight__g7BfP span {
  color: #666666 !important;
}

.AttendeeCustomTable_menulinklight__g7BfP a {
  color: #CBCBCB !important;
}

.AttendeeCustomTable_menulinklight__g7BfP:hover span,
.AttendeeCustomTable_menulinklight__g7BfP:hover a {
  color: #fff !important;
}

.AttendeeCustomTable_menulinkdarkSelected__tRIFG {
  background-color: #1c2e45;
  color: #3b82f6;
}

.AttendeeCustomTable_menuthemelight__wQ\\+6e .AttendeeCustomTable_menulinklightSelected__UnJpq {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #131F43 !important;
}

.AttendeeCustomTable_menulinkdark__\\+srHQ {
  color: #92afd3 !important;
}

.AttendeeCustomTable_menulinklight__g7BfP:hover {
  color: #fff !important;
  background-color: #131F43 !important;
}

.AttendeeCustomTable_menulinklight__g7BfP .AttendeeCustomTable_sub_arrow__h6ARI svg path {
  stroke: #CBCBCB !important;
}

.AttendeeCustomTable_menulinklight__g7BfP:hover .AttendeeCustomTable_sub_arrow__h6ARI svg path {
  stroke: #fff !important;
}

.AttendeeCustomTable_menulinkdark__\\+srHQ .AttendeeCustomTable_sub_arrow__h6ARI svg path {
  stroke: #92afd3 !important;
}

.AttendeeCustomTable_menulinkdark__\\+srHQ:hover .AttendeeCustomTable_sub_arrow__h6ARI svg path {
  stroke: #fff !important;
}

.AttendeeCustomTable_menulinklight__g7BfP:hover svg path,
.AttendeeCustomTable_menulinklightSelected__UnJpq svg path {
  fill: #fff !important;
}

.AttendeeCustomTable_menulinkdark__\\+srHQ:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.AttendeeCustomTable_headinglight__2yuFe {
  color: #60677e;
}

.AttendeeCustomTable_headingdark__ghMSk {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.AttendeeCustomTable_searchboxlight__T8h28 {
  background-color: #fff;
  border: none;
}

.AttendeeCustomTable_searchboxdark__Fc-G5 {
  background-color: #132337;
  color: #fff;
  border: none;
}

.AttendeeCustomTable_searchboxdark__Fc-G5::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.AttendeeCustomTable_tableheadlight__KxfZg {
  background-color: #131F43;
  border-radius: 5px 5px 0px 0px;
}

.AttendeeCustomTable_tableheadlight__KxfZg th {
  color: #fff;
}

thead .AttendeeCustomTable_tableheadlight__KxfZg th:first-child,
thead .AttendeeCustomTable_tableheaddark__wIhca th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .AttendeeCustomTable_tableheadlight__KxfZg th:last-child,
thead .AttendeeCustomTable_tableheaddark__wIhca th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.AttendeeCustomTable_table__5S-F2.AttendeeCustomTable_table-borderless__2mPFq {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.AttendeeCustomTable_tableheaddark__wIhca {
  background-color: #132337;
  color: #fff;
}

.AttendeeCustomTable_table-borderless__2mPFq tr:nth-child(even) {
  background-color: #F9FAFB;
}

.AttendeeCustomTable_table-borderless__2mPFq .AttendeeCustomTable_left-section__oyvL0 {
  padding-top: 10px;
}

.AttendeeCustomTable_tablebodylight__pdgcp td,
.AttendeeCustomTable_tablebodydark__qAncM td {
  padding: 0.5rem 1rem !important;
  line-height: 45px;
}

.AttendeeCustomTable_tablebodylight__pdgcp {
  background-color: #fff;
}
.AttendeeCustomTable_tablebodylight__pdgcp:hover {
  background-color: #fff;
  cursor: auto;
}
.AttendeeCustomTable_tablebodylight__pdgcp p {
  line-height: 24px;
}

.AttendeeCustomTable_tablebodydark__qAncM {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.AttendeeCustomTable_tablebodydark__qAncM:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: pointer;
}

/* 
PAGINATION THEME COLOR
*/
.AttendeeCustomTable_paginationlight__40Aii {
  color: #60677e !important;
  font-size: 13px !important;
}

.AttendeeCustomTable_paginationdark__4R6bb {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.AttendeeCustomTable_formthemelight__TKLpc {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.AttendeeCustomTable_formthemedark__lm8-U {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.AttendeeCustomTable_formthemedark__lm8-U ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.AttendeeCustomTable_viewformlight__evfnU {
  background-color: #f3f6f9;
}

.AttendeeCustomTable_permissionboxlight__hZBAe {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.AttendeeCustomTable_permissionboxdark__B9ap7 {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.AttendeeCustomTable_errormsgclr__fHGm5 {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.AttendeeCustomTable_graphclrlight__f3TwN {
  background-color: #fff;
}

.AttendeeCustomTable_graphclrdark__C5z2h {
  background-color: #132337;
}

/* 
Counter theme
*/
#AttendeeCustomTable_card1bglight__9LW9u {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#AttendeeCustomTable_card1bgdark__dRgRB {
  background: #392f28;
}

#AttendeeCustomTable_card2bglight__34AQ0 {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#AttendeeCustomTable_card2bgdark__kSbyi {
  background: #1c3238;
}

#AttendeeCustomTable_card3bglight__20AQ5 {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#AttendeeCustomTable_card3bgdark__PvhS2 {
  background: #3a2434;
}

#AttendeeCustomTable_card4bglight__iBmgK {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#AttendeeCustomTable_card4bgdark__A-nK2 {
  background: #2f264f;
}

#AttendeeCustomTable_card1bgdark__dRgRB a,
#AttendeeCustomTable_card1bgdark__dRgRB p,
#AttendeeCustomTable_card2bgdark__kSbyi a,
#AttendeeCustomTable_card2bgdark__kSbyi p,
#AttendeeCustomTable_card3bgdark__PvhS2 a,
#AttendeeCustomTable_card3bgdark__PvhS2 p,
#AttendeeCustomTable_card4bgdark__A-nK2 a,
#AttendeeCustomTable_card4bgdark__A-nK2 p {
  color: #fff;
}

/* 
Action button theme
*/
.AttendeeCustomTable_actionbtnlight__oVVbZ {
  color: rgba(70, 71, 91, 0.8705882353);
}

.AttendeeCustomTable_actionbtndark__b6SuU {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.AttendeeCustomTable_profiledropdownlight__Esary {
  background-color: #fff;
}

.AttendeeCustomTable_profiledropdowndark__ZKBNt {
  background-color: #151521;
}

.AttendeeCustomTable_settingsection__Bfq\\+v #AttendeeCustomTable_addform__SXsM9.AttendeeCustomTable_formthemedark__lm8-U .AttendeeCustomTable_savebtn__6wLWt {
  background-color: #3b82f6;
  color: #fff;
}

#AttendeeCustomTable_addform__SXsM9.AttendeeCustomTable_formthemedark__lm8-U .AttendeeCustomTable_savebtn__6wLWt {
  background-color: #3b82f6;
  color: #fff;
}

.AttendeeCustomTable_profile_conatiner__KnlOE {
  border-radius: 5px !important;
}

.AttendeeCustomTable_bodythemedark__aBYIU .AttendeeCustomTable_ag-theme-alpine__ZXAFI .AttendeeCustomTable_ag-row__OHnLq {
  background: #000 !important;
}

.AttendeeCustomTable_bodythemedark__aBYIU .AttendeeCustomTable_formbtn__aCSGq {
  background-color: #3b82f6;
}

.AttendeeCustomTable_bodythemedark__aBYIU .AttendeeCustomTable_formbtn__aCSGq:hover {
  background-color: #2563eb;
}

.AttendeeCustomTable_bodythemedark__aBYIU .AttendeeCustomTable_resetbtn__ljCy- {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.AttendeeCustomTable_bodythemedark__aBYIU .AttendeeCustomTable_resetbtn__ljCy-:hover {
  background-color: #3b82f6;
}

.AttendeeCustomTable_headingdark__ghMSk span {
  background-color: #132337;
}

.AttendeeCustomTable_resetbtn__ljCy- {
  font-size: 16px !important;
  font-weight: 600 !important;
  border-radius: 5px !important;
  background-color: transparent !important;
  border: solid 1px #131F43 !important;
  color: #131F43 !important;
  min-width: 113px !important;
}

.AttendeeCustomTable_resetbtn__ljCy-:hover,
.AttendeeCustomTable_resetbtn__ljCy-:active,
.AttendeeCustomTable_resetbtn__ljCy-:focus {
  background-color: #131F43 !important;
  color: #fff !important;
}

.AttendeeCustomTable_addBtn__YJnoY {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.AttendeeCustomTable_addDltBtn__7aHOO {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.AttendeeCustomTable_addbtnlight__948dV {
  background-color: #38A169;
}

.AttendeeCustomTable_addbtndark__26l-y {
  background-color: #3b82f6;
}

.AttendeeCustomTable_addbtndark__26l-y:hover {
  background-color: #2563eb;
}

.AttendeeCustomTable_formthemedark__lm8-U label {
  color: #92afd3;
}

.AttendeeCustomTable_addBtn__YJnoY svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.AttendeeCustomTable_addBtn__YJnoY:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.AttendeeCustomTable_cust_addBtn__rVSnr.AttendeeCustomTable_addBtn__YJnoY svg {
  top: 2px;
}

.AttendeeCustomTable_deleteBtn__KsvX9 {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.AttendeeCustomTable_deleteBtn__KsvX9 {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.AttendeeCustomTable_deleteBtn__KsvX9:active,
.AttendeeCustomTable_deleteBtn__KsvX9:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.AttendeeCustomTable_deleteBtn__KsvX9 svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.AttendeeCustomTable_deleteBtn__KsvX9:hover,
.AttendeeCustomTable_deleteBtn__KsvX9:active,
.AttendeeCustomTable_deleteBtn__KsvX9:focus {
  background-color: #F94747;
  color: #fff;
  border: none;
}

.AttendeeCustomTable_confirmBtn__P\\+GTu {
  background-color: #131F43 !important;
  min-width: 130px !important;
  height: 50px !important;
  color: #fff !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border: none !important;
}

.AttendeeCustomTable_confirmBtn__P\\+GTu:hover,
.AttendeeCustomTable_confirmBtn__P\\+GTu:active,
.AttendeeCustomTable_confirmBtn__P\\+GTu:focus {
  background-color: #0f1824 !important;
}

.AttendeeCustomTable_confirmBtn__P\\+GTu svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.AttendeeCustomTable_delPopContainer__xhcoA .AttendeeCustomTable_modal-body__Cz2Ep {
  padding: 35px;
  text-align: center;
}

.AttendeeCustomTable_delPopContainer__xhcoA .AttendeeCustomTable_delet_icon__P4-5Z {
  margin-bottom: 11px;
}

.AttendeeCustomTable_delPopContainer__xhcoA p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
  padding: 0 20px;
}

.AttendeeCustomTable_arrowback__jXmv0 svg {
  fill: #000;
}

.AttendeeCustomTable_bodythemedark__aBYIU .AttendeeCustomTable_arrowback__jXmv0 {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.AttendeeCustomTable_bodythemedark__aBYIU .AttendeeCustomTable_arrowback__jXmv0 svg {
  fill: #3b82f6;
}

.AttendeeCustomTable_bodythemedark__aBYIU .AttendeeCustomTable_drpdwn_btn__0xF-4 {
  background-color: #132337;
}

.AttendeeCustomTable_bodythemedark__aBYIU .AttendeeCustomTable_empname__\\+7jN8 {
  color: #92afd3 !important;
}

.AttendeeCustomTable_bodythemedark__aBYIU .AttendeeCustomTable_navitemli__TqhdC a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.AttendeeCustomTable_bodythemedark__aBYIU .AttendeeCustomTable_tabnavli__b7GqZ a.AttendeeCustomTable_settingsgeneral__SwlNi,
.AttendeeCustomTable_bodythemedark__aBYIU .AttendeeCustomTable_tabnavli__b7GqZ a.AttendeeCustomTable_settingslinks__Ag6yJ:hover {
  background-color: #3b82f6;
  color: #fff;
}

.AttendeeCustomTable_bodythemedark__aBYIU .AttendeeCustomTable_tabnavli__b7GqZ a.AttendeeCustomTable_settingslinks__Ag6yJ {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.AttendeeCustomTable_headerthemedark__rrIXM .AttendeeCustomTable_dropdown_menu_contain__0x2Mm {
  background-color: #1c2e45;
  color: #fff;
}

.AttendeeCustomTable_headerthemedark__rrIXM .AttendeeCustomTable_dropdown_menu_contain__0x2Mm ul li a,
.AttendeeCustomTable_headerthemedark__rrIXM .AttendeeCustomTable_dropdown_menu_contain__0x2Mm .AttendeeCustomTable_dropdown_item__ePkjb,
.AttendeeCustomTable_headerthemedark__rrIXM .AttendeeCustomTable_dropdown_menu_contain__0x2Mm .AttendeeCustomTable_dropdown_item__ePkjb h5 {
  color: #fff;
}

.AttendeeCustomTable_headerthemedark__rrIXM .AttendeeCustomTable_dropdown_menu_contain__0x2Mm ul li a:hover,
.AttendeeCustomTable_headerthemedark__rrIXM .AttendeeCustomTable_dropdown_menu_contain__0x2Mm .AttendeeCustomTable_dropdown_item__ePkjb:hover {
  background-color: #132337;
  color: #fff;
}

.AttendeeCustomTable_dropdown_item__ePkjb:active {
  background-color: #F5F6FA;
}

.AttendeeCustomTable_profile_arrrow_dwn__X24e- {
  stroke: #132337;
}

.AttendeeCustomTable_headerthemedark__rrIXM .AttendeeCustomTable_profile_arrrow_dwn__X24e- {
  stroke: #fff;
}

.AttendeeCustomTable_dateinputbox1__H9kdw input,
.AttendeeCustomTable_dateinputbox1__H9kdw span {
  color: #fff !important;
}

/* LOGOUT MODAL */
.AttendeeCustomTable_delPopContainer__xhcoA .AttendeeCustomTable_modal-content__J1sSs {
  border-radius: 10px;
  min-width: 399px;
}

.AttendeeCustomTable_larg_model__UJOhp .AttendeeCustomTable_modal-dialog__lQ247 {
  max-width: 100% !important;
}

.AttendeeCustomTable_larg_model__UJOhp .AttendeeCustomTable_modal-content__J1sSs {
  /* display: inline-block; */
  height: 100%;
  max-width: 900px;
  margin: auto;
  border-radius: 54px !important;
  background: #FFF;
  padding: 53px 53px 23px;
}

.AttendeeCustomTable_larg_model__UJOhp .AttendeeCustomTable_modal-header__yQJ5J {
  padding: 0px 0px 23px;
  border-bottom: 1px dashed #D4D9EE;
  display: block;
}

body .AttendeeCustomTable_btn-primary__7phB5:hover {
  background-color: transparent;
  border-color: #131F43;
  color: #131F43;
  fill: #131F43;
  border: 1px solid;
}

.AttendeeCustomTable_form-select__b\\+156 {
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  -moz-padding-start: calc(0.75rem - 3px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}

thead .AttendeeCustomTable_CustomTable_tableheadlight__HuHZw__INszt th:first-child,
thead .AttendeeCustomTable_CustomTable_tableheaddark__nwqb4__Ydh-G th:first-child {
  border-radius: 5px 0 0 0px;
  display: math;
}

th:first-child {
  border-radius: 0px;
  position: absolute;
}

@media only screen and (max-width: 1200px) {
  .AttendeeCustomTable_tableheadlight__KxfZg th {
    min-width: 270px;
  }
}
@media only screen and (max-width: 1024px) {
  .AttendeeCustomTable_dashboard__ar5py {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
    overflow-x: hidden !important;
  }
  .AttendeeCustomTable_cont2__vnuPv {
    height: auto !important;
    padding-bottom: 10px !important;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
    height: auto !important;
  }*/
}
@media only screen and (max-width: 767px) {
  .AttendeeCustomTable_sectionright__VsLJr {
    float: unset !important;
  }
  .AttendeeCustomTable_dashboard__ar5py {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .AttendeeCustomTable_cont2__vnuPv {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px 10px 15px !important;
  }
  .AttendeeCustomTable_bodythemelight__Fycx\\+,
.AttendeeCustomTable_bodythemedark__aBYIU {
    padding-top: 110px;
  }
  .AttendeeCustomTable_delPopContainer__xhcoA .AttendeeCustomTable_modal-content__J1sSs {
    min-width: 100%;
  }
  .AttendeeCustomTable_delPopContainer__xhcoA .AttendeeCustomTable_modal-body__Cz2Ep {
    padding: 15px;
  }
  .AttendeeCustomTable_larg_model__UJOhp .AttendeeCustomTable_modal-content__J1sSs {
    border-radius: 20px !important;
    padding: 22px;
  }
}
@media (min-width: 576px) {
  .AttendeeCustomTable_exer_modal_contain__OBVAt .AttendeeCustomTable_modal-dialog__lQ247 {
    max-width: 1055px;
  }
  .AttendeeCustomTable_delPopContainer__xhcoA .AttendeeCustomTable_modal-dialog__lQ247 {
    max-width: 350px;
  }
  /*.tableheadlight th {
    min-width: 120px;
  } */
}
/* vk new changes */
.AttendeeCustomTable_active_show_outer__8xIOk h2 {
  color: var(--Font-black, #0B0D0F);
  font-family: Urbanist;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
@media screen and (max-width: 768px) {
  .AttendeeCustomTable_active_show_outer__8xIOk h2 {
    margin-top: 15px;
  }
}
.AttendeeCustomTable_active_show_outer__8xIOk .AttendeeCustomTable_active_show_inner__0XBsl {
  width: 100%;
  display: block;
}
.AttendeeCustomTable_active_show_outer__8xIOk .AttendeeCustomTable_active_show_inner__0XBsl .AttendeeCustomTable_act_box_img__HmdoN {
  margin-bottom: 12px;
  min-height: 400px;
  object-fit: cover;
  overflow: hidden;
  height: 400px;
  max-height: 400px;
}
@media (max-width: 767px) {
  .AttendeeCustomTable_active_show_outer__8xIOk .AttendeeCustomTable_active_show_inner__0XBsl .AttendeeCustomTable_act_box_img__HmdoN {
    min-height: 300px;
    height: 300px;
    max-height: 300px;
  }
}
.AttendeeCustomTable_active_show_outer__8xIOk .AttendeeCustomTable_active_show_inner__0XBsl .AttendeeCustomTable_act_box_img__HmdoN img {
  max-height: 400px;
  /* align-self: stretch; */
  width: 100%;
  height: 100%;
  border-radius: 12px;
  object-fit: cover;
}
.AttendeeCustomTable_active_show_outer__8xIOk .AttendeeCustomTable_active_show_inner__0XBsl .AttendeeCustomTable_act_box_cnt__CO0Vi {
  width: 100%;
  display: block;
}
.AttendeeCustomTable_active_show_outer__8xIOk .AttendeeCustomTable_active_show_inner__0XBsl .AttendeeCustomTable_act_box_cnt__CO0Vi svg {
  flex-shrink: 0;
}
.AttendeeCustomTable_active_show_outer__8xIOk .AttendeeCustomTable_active_show_inner__0XBsl .AttendeeCustomTable_act_box_cnt__CO0Vi .AttendeeCustomTable_act_box_bdg__RyeZr {
  width: 100%;
  margin-bottom: 12px;
}
.AttendeeCustomTable_active_show_outer__8xIOk .AttendeeCustomTable_active_show_inner__0XBsl .AttendeeCustomTable_act_box_cnt__CO0Vi .AttendeeCustomTable_act_box_bdg__RyeZr span {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right top no-repeat;
  width: 111px;
  display: block;
  height: 34px;
  color: var(--White, #FFF);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  padding: 3px 8px;
}
.AttendeeCustomTable_active_show_outer__8xIOk .AttendeeCustomTable_active_show_inner__0XBsl .AttendeeCustomTable_act_box_cnt__CO0Vi .AttendeeCustomTable_act_box_bdg__RyeZr .AttendeeCustomTable_sold__yDKjh {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) right top no-repeat !important;
}
.AttendeeCustomTable_active_show_outer__8xIOk .AttendeeCustomTable_active_show_inner__0XBsl .AttendeeCustomTable_act_box_cnt__CO0Vi h3 {
  color: var(--Secondary, #132941);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 26.304px;
  margin: 0;
}
.AttendeeCustomTable_active_show_outer__8xIOk .AttendeeCustomTable_active_show_inner__0XBsl .AttendeeCustomTable_act_box_cnt__CO0Vi p {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 5px;
}
.AttendeeCustomTable_active_show_outer__8xIOk .AttendeeCustomTable_active_show_inner__0XBsl .AttendeeCustomTable_act_box_cnt__CO0Vi p span {
  color: var(--Light-1, #736B66);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 26.304px;
}
.AttendeeCustomTable_active_show_outer__8xIOk .AttendeeCustomTable_active_show_inner__0XBsl .AttendeeCustomTable_act_box_cnt__CO0Vi p .AttendeeCustomTable_timezone_code_pill__Xv1ut {
  display: inline-block;
  padding: 2px 8px;
  margin-left: 4px;
  background: #e0f2fe;
  color: #0369a1;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  border-radius: 6px;
}

/* vk new changes */
#AttendeeCustomTable_attent_details_row1__QzaqR {
  margin-bottom: 0 !important;
}

.AttendeeCustomTable_attent_details__UE-T8 .AttendeeCustomTable_attent_details_inner__\\+5muo {
  display: flex;
  gap: 61px;
  padding: 20px;
  border-radius: 5px;
  background: #FFF;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
  align-items: center;
}
@media (max-width: 576px) {
  .AttendeeCustomTable_attent_details__UE-T8 .AttendeeCustomTable_attent_details_inner__\\+5muo {
    display: block !important;
  }
}
@media (max-width: 992px) {
  .AttendeeCustomTable_attent_details__UE-T8 .AttendeeCustomTable_attent_details_inner__\\+5muo {
    display: flex;
    gap: 20px;
    align-items: start;
  }
}
.AttendeeCustomTable_attent_details__UE-T8 .AttendeeCustomTable_attent_details_inner__\\+5muo .AttendeeCustomTable_attent_details_inner_l__s4ZJ1 img {
  width: 187px;
  height: 207px;
  flex-shrink: 0;
  object-fit: cover;
}
.AttendeeCustomTable_attent_details__UE-T8 .AttendeeCustomTable_attent_details_inner__\\+5muo .AttendeeCustomTable_attent_details_inner_r__VBJS6 {
  flex: 1 1;
}
.AttendeeCustomTable_attent_details__UE-T8 .AttendeeCustomTable_attent_details_inner__\\+5muo .AttendeeCustomTable_attent_details_inner_r__VBJS6 .AttendeeCustomTable_attent_details_row__MRKC7 {
  display: flex;
  gap: 20px;
  margin-bottom: 28px;
}
@media (max-width: 992px) {
  .AttendeeCustomTable_attent_details__UE-T8 .AttendeeCustomTable_attent_details_inner__\\+5muo .AttendeeCustomTable_attent_details_inner_r__VBJS6 .AttendeeCustomTable_attent_details_row__MRKC7 {
    margin-bottom: 0px;
    display: inline-block;
    width: 100%;
  }
}
.AttendeeCustomTable_attent_details__UE-T8 .AttendeeCustomTable_attent_details_inner__\\+5muo .AttendeeCustomTable_attent_details_inner_r__VBJS6 .AttendeeCustomTable_attent_details_row__MRKC7 .AttendeeCustomTable_attent_details_row_box__Dcn\\+4 {
  flex: 1 1;
  width: 22%;
}
@media (max-width: 576px) {
  .AttendeeCustomTable_attent_details__UE-T8 .AttendeeCustomTable_attent_details_inner__\\+5muo .AttendeeCustomTable_attent_details_inner_r__VBJS6 .AttendeeCustomTable_attent_details_row__MRKC7 .AttendeeCustomTable_attent_details_row_box__Dcn\\+4 {
    margin: 15px 0px 10px !important;
    width: 100% !important;
  }
}
@media (max-width: 992px) {
  .AttendeeCustomTable_attent_details__UE-T8 .AttendeeCustomTable_attent_details_inner__\\+5muo .AttendeeCustomTable_attent_details_inner_r__VBJS6 .AttendeeCustomTable_attent_details_row__MRKC7 .AttendeeCustomTable_attent_details_row_box__Dcn\\+4 {
    margin-bottom: 15px;
    float: left;
    margin-right: 0;
    width: 50%;
    padding-right: 10px;
  }
}
.AttendeeCustomTable_attent_details__UE-T8 .AttendeeCustomTable_attent_details_inner__\\+5muo .AttendeeCustomTable_attent_details_inner_r__VBJS6 .AttendeeCustomTable_attent_details_row__MRKC7 .AttendeeCustomTable_attent_details_row_box__Dcn\\+4 p {
  margin-bottom: 10px;
  color: #727272;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.AttendeeCustomTable_attent_details__UE-T8 .AttendeeCustomTable_attent_details_inner__\\+5muo .AttendeeCustomTable_attent_details_inner_r__VBJS6 .AttendeeCustomTable_attent_details_row__MRKC7 .AttendeeCustomTable_attent_details_row_box__Dcn\\+4 h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  word-wrap: break-word;
}
.AttendeeCustomTable_attent_details__UE-T8 .AttendeeCustomTable_attent_details_inner__\\+5muo .AttendeeCustomTable_attent_details_inner_r__VBJS6 .AttendeeCustomTable_attent_details_row_last__2pV44 {
  margin-bottom: 0px !important;
}
.AttendeeCustomTable_attent_details__UE-T8 .AttendeeCustomTable_attent_details_inner__\\+5muo .AttendeeCustomTable_attent_details_inner_r__VBJS6 .AttendeeCustomTable_attent_details_row_last__2pV44.AttendeeCustomTable_interesting_fact__hV\\+i6 {
  padding-top: 30px;
}
.AttendeeCustomTable_attent_details__UE-T8 .AttendeeCustomTable_attent_details_inner__\\+5muo .AttendeeCustomTable_attent_details_inner_r__VBJS6 .AttendeeCustomTable_attent_details_row_last__2pV44.AttendeeCustomTable_interesting_fact__hV\\+i6 .AttendeeCustomTable_attent_details_row_box__Dcn\\+4 {
  width: 100%;
}
.AttendeeCustomTable_attent_details__UE-T8 .AttendeeCustomTable_attent_details_inner__\\+5muo .AttendeeCustomTable_attent_details_inner_r__VBJS6 .AttendeeCustomTable_attent_details_row_last__2pV44.AttendeeCustomTable_interesting_fact__hV\\+i6 .AttendeeCustomTable_attent_details_row_box__Dcn\\+4 h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

.AttendeeCustomTable_showbox_sec__YPor7 {
  display: flex;
  justify-content: flex-start;
  gap: 0;
  flex-direction: row;
  flex-wrap: wrap;
}
@media screen and (max-width: 500px) {
  .AttendeeCustomTable_showbox_sec__YPor7 {
    justify-content: center;
  }
}

.AttendeeCustomTable_show_box_main__3PUud {
  margin: 10px 0px;
}
.AttendeeCustomTable_show_box_main__3PUud .AttendeeCustomTable_show_box__ZKqsy {
  min-height: 600px;
  width: 300px;
  float: left;
  margin-right: 20px;
  margin-bottom: 20px;
  cursor: pointer;
}
@media (max-width: 1024px) {
  .AttendeeCustomTable_show_box_main__3PUud .AttendeeCustomTable_show_box__ZKqsy {
    margin-right: 18px;
  }
}
@media (max-width: 767px) {
  .AttendeeCustomTable_show_box_main__3PUud .AttendeeCustomTable_show_box__ZKqsy {
    min-height: 500px;
    width: 200px !important;
  }
}
.AttendeeCustomTable_show_box_main__3PUud .AttendeeCustomTable_show_box__ZKqsy img {
  max-height: 400px;
  height: 100%;
  width: 100%;
}
@media (max-width: 767px) {
  .AttendeeCustomTable_show_box_main__3PUud .AttendeeCustomTable_show_box__ZKqsy img {
    max-height: 300px !important;
  }
}
.AttendeeCustomTable_show_box_main__3PUud .AttendeeCustomTable_show_box__ZKqsy:last-child {
  margin-right: 0px !important;
}
.AttendeeCustomTable_show_box_main__3PUud .AttendeeCustomTable_no_show_box__gI-I1 {
  width: 350px;
  margin: 0 auto 20px;
  display: block;
}
@media (max-width: 767px) {
  .AttendeeCustomTable_show_box_main__3PUud .AttendeeCustomTable_no_show_box__gI-I1 {
    width: 250px !important;
  }
}
.AttendeeCustomTable_show_box_main__3PUud .AttendeeCustomTable_no_show_box__gI-I1 img {
  max-height: 450px;
  height: 100%;
  width: 100%;
}
@media (max-width: 767px) {
  .AttendeeCustomTable_show_box_main__3PUud .AttendeeCustomTable_no_show_box__gI-I1 img {
    max-height: 350px !important;
  }
}
.AttendeeCustomTable_show_box_main__3PUud .AttendeeCustomTable_no_show_box__gI-I1 h6 {
  color: #000;
  text-align: center;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 20px;
}
@media only screen and (max-width: 600px) {
  .AttendeeCustomTable_show_box_main__3PUud .AttendeeCustomTable_no_show_box__gI-I1 h6 {
    font-size: 20px;
  }
}

.AttendeeCustomTable_attent_flex__LuDTd {
  justify-content: space-between !important;
  gap: 30px;
  align-items: center;
}
.AttendeeCustomTable_attent_flex__LuDTd h5 {
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
}

#AttendeeCustomTable_container__xcoZC {
  padding: 0px;
}

#AttendeeCustomTable_tableheading__GyDGF {
  font-size: 16px;
  margin-top: 20px;
}

.AttendeeCustomTable_search_box__QlVKg {
  position: relative;
}

thead .AttendeeCustomTable_CustomTable_tableheadlight__HuHZw__INszt th:first-child, thead .AttendeeCustomTable_CustomTable_tableheaddark__nwqb4__Ydh-G th:first-child {
  display: math !important;
}

#AttendeeCustomTable_spinner__P97Nm {
  float: right;
  margin-top: -25px;
  position: relative;
  z-index: 1;
  margin-right: 10px;
  cursor: pointer;
  color: #131F43;
}

.AttendeeCustomTable_tbl_sl__Sghd- {
  min-width: 10px !important;
}

.AttendeeCustomTable_tablebtn__GB0Ut {
  width: 70px;
  padding: 6px;
  border: none;
  background-color: #131F43;
  border-radius: 5px;
  color: #fff;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 14px;
}
.AttendeeCustomTable_tablebtn__GB0Ut:hover {
  background-color: rgba(37, 105, 109, 0.864);
}

table {
  border-collapse: separate !important;
  border-spacing: 0 6px !important;
}

td:first-child,
th:first-child {
  border-radius: 8px 0 0 8px;
}

td:last-child,
th:last-child {
  border-radius: 0 8px 8px 0;
}

.AttendeeCustomTable_tableheaddiv__teRA8 {
  display: flex;
}

th, td {
  font-size: 14px;
}

th {
  padding: 0.8rem 1rem !important;
}

td {
  padding: 0.5rem 1rem !important;
  line-height: 28px;
}

.AttendeeCustomTable_sortbtn__47Ecs {
  border: none;
  background: none;
  color: #6E6E6E;
}

.AttendeeCustomTable_order_date__mmWt7 {
  margin-top: 5px;
  font-size: 12px;
  color: #000;
  font-weight: normal;
}

h6 {
  color: #000;
}

.AttendeeCustomTable_norecord__AfH9d {
  font-size: 22px;
  margin-top: 10px;
  color: #939090;
}

.AttendeeCustomTable_norecordsdiv__1\\+bE\\+ {
  position: absolute;
  left: 42%;
  margin-top: 2%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.AttendeeCustomTable_ststus_text__gewaA {
  font-size: 14px;
  font-weight: 600;
  padding-left: 8px;
}

.AttendeeCustomTable_ststus_not_verified__9EDWK {
  color: #9f9e9d;
}

.AttendeeCustomTable_ststus_verified__Xn1oa {
  color: #00ba00;
}

.AttendeeCustomTable_ststus_cancelled__Ywp6j {
  color: #ff0000;
}

.AttendeeCustomTable_refund__-dSx6 {
  padding-left: 10px;
}

.AttendeeCustomTable_refund__-dSx6 button {
  padding: 0;
  background-color: transparent;
  border: none;
}

.AttendeeCustomTable_refund__-dSx6 button:hover {
  background-color: transparent;
  border: none;
  box-shadow: none;
  outline: none;
}

.AttendeeCustomTable_refund__-dSx6 button:active {
  background-color: transparent;
  border: none;
  box-shadow: none;
  outline: none;
}

.AttendeeCustomTable_refund__-dSx6 button:focus {
  background-color: transparent;
  border: none;
  box-shadow: none !important;
  outline: none;
}

.AttendeeCustomTable_refund_tooltip__Bg-mU {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;
}

.AttendeeCustomTable_refund_tooltip__Bg-mU .AttendeeCustomTable_tooltiptext__r6xdz {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
}

.AttendeeCustomTable_refund_tooltip__Bg-mU:hover .AttendeeCustomTable_tooltiptext__r6xdz {
  visibility: visible;
}

.AttendeeCustomTable_search_contain_box__OcQ1e {
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  margin-bottom: 20px;
}
@media screen and (max-width: 1240px) {
  .AttendeeCustomTable_search_contain_box__OcQ1e {
    flex-direction: column;
    align-items: center;
  }
}

.AttendeeCustomTable_search_contain_box1__DdZQY {
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  margin: 20px 0;
}

.AttendeeCustomTable_tabbtn__2KYu\\+ {
  display: flex;
  gap: 1rem;
}

.AttendeeCustomTable_totalamt__LT2p4 {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 5px;
  border: 1px solid #EAEAEA;
  color: var(--Font-black, #0B0D0F);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  height: 42px;
  padding: 10px;
}

.AttendeeCustomTable_totalamt__LT2p4 span {
  color: var(--Green, #00C16B);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.AttendeeCustomTable_totalamt1__Jpdbh {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 5px;
  border: 1px solid #EAEAEA;
  color: var(--Font-black, #0B0D0F);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  height: 42px;
  padding: 10px;
}

.AttendeeCustomTable_search_contain_box1__DdZQY h5 {
  margin: 0 !important;
  padding: 0 !important;
}

.AttendeeCustomTable_totalamt1__Jpdbh ul {
  list-style: none;
  display: flex;
  gap: 10px;
  padding: 0 !important;
  margin: 0;
}

.AttendeeCustomTable_totalamt1__Jpdbh span {
  color: var(--Primary, #FD9800);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.AttendeeCustomTable_Total_count__KQSZL {
  display: flex;
  gap: 15px;
  align-items: center;
  margin-bottom: 20px;
  margin-right: 15px;
  justify-content: flex-end;
}

.AttendeeCustomTable_Total_seat_count__z-M-N {
  font-size: 16px;
  font-weight: 700;
}

.AttendeeCustomTable_Total_seat_count__z-M-N span {
  background: #07bf0d;
  padding: 5px;
  border-radius: 3px;
  color: #fff;
}

.AttendeeCustomTable_user_tb_hd__avwA4 {
  display: flex;
  gap: 14px;
  flex-direction: column;
  justify-content: space-between;
}
@media only screen and (max-width: 767px) {
  .AttendeeCustomTable_user_tb_hd__avwA4 {
    flex-direction: column;
  }
}
.AttendeeCustomTable_user_tb_hd__avwA4 .AttendeeCustomTable_info_contain__Me548 {
  background-color: #D1ECF1;
  border: solid 1px #BEE5EB;
  border-radius: 4px;
  padding: 10px 30px 10px 20px;
  display: flex;
  gap: 12px;
  align-items: center;
  height: 48px;
}
@media only screen and (max-width: 767px) {
  .AttendeeCustomTable_user_tb_hd__avwA4 .AttendeeCustomTable_info_contain__Me548 {
    flex-direction: column;
    height: auto;
  }
}
@media screen and (min-width: 766px) and (max-width: 1231px) {
  .AttendeeCustomTable_user_tb_hd__avwA4 .AttendeeCustomTable_info_contain__Me548 {
    border-radius: 4px;
    padding: 30px 30px 30px 20px;
    display: flex;
    gap: 12px;
    align-items: center;
    height: 45px;
  }
}
.AttendeeCustomTable_user_tb_hd__avwA4 .AttendeeCustomTable_info_contain__Me548 .AttendeeCustomTable_info_content__HN7om {
  display: flex;
  gap: 12px;
}
@media only screen and (max-width: 767px) {
  .AttendeeCustomTable_user_tb_hd__avwA4 .AttendeeCustomTable_info_contain__Me548 .AttendeeCustomTable_info_content__HN7om {
    flex-direction: column;
  }
}
@media screen and (max-width: 1231px) {
  .AttendeeCustomTable_user_tb_hd__avwA4 .AttendeeCustomTable_info_contain__Me548 .AttendeeCustomTable_info_content__HN7om {
    display: flex;
    gap: 0px;
    flex-direction: column;
  }
}
.AttendeeCustomTable_user_tb_hd__avwA4 .AttendeeCustomTable_info_contain__Me548 p {
  margin: 0px;
  color: #0C5460;
  font-size: 16px;
  font-weight: 500;
}
@media only screen and (max-width: 767px) {
  .AttendeeCustomTable_user_tb_hd__avwA4 .AttendeeCustomTable_info_contain__Me548 p {
    text-align: center;
  }
}
.AttendeeCustomTable_user_tb_hd__avwA4 .AttendeeCustomTable_info_contain__Me548 button {
  height: unset;
  background-color: transparent;
  border: none;
  padding: 0px;
  font-size: 16px;
  font-weight: 700;
  color: #0C5460;
  text-decoration: underline;
}
.AttendeeCustomTable_user_tb_hd__avwA4 .AttendeeCustomTable_info_contain__Me548 button:hover {
  color: #1492a7;
}
.AttendeeCustomTable_user_tb_hd__avwA4 .AttendeeCustomTable_info_contain__Me548 button:focus {
  outline: none;
  border: none;
  box-shadow: none;
}

.AttendeeCustomTable_sectionright__VsLJr {
  float: right;
  display: flex;
  gap: 30px;
}
.AttendeeCustomTable_sectionright__VsLJr #AttendeeCustomTable_dropdown__8ExS4 {
  margin: 0px 10px 10px 10px;
}
.AttendeeCustomTable_sectionright__VsLJr #AttendeeCustomTable_dropdown__8ExS4 button {
  background-color: #131F43;
  border-radius: 5px;
  border: none;
  box-shadow: none;
  font-size: 14px;
  min-width: 140px;
  min-height: 44px;
}
.AttendeeCustomTable_sectionright__VsLJr a {
  font-size: 14px;
}
.AttendeeCustomTable_sectionright__VsLJr #AttendeeCustomTable_del_icon__oWLMh {
  font-size: 12px;
  margin-left: 5px;
}

.AttendeeCustomTable_tdactive__Q9CO8 {
  padding: 8px 10px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  margin-top: 8px;
  background: rgba(0, 193, 107, 0.2);
  color: #00C16B;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
  margin-top: 8px;
}

.AttendeeCustomTable_tdinactive__0HIXZ {
  padding: 8px 10px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background: rgba(255, 0, 0, 0.2);
  color: #F00;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
  margin-top: 8px;
}

.AttendeeCustomTable_tdyellowbg__PbpMV {
  padding: 8px 10px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background: rgba(253, 152, 0, 0.2);
  color: #FD9800;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
  margin-top: 8px;
}

.AttendeeCustomTable_arrowback__jXmv0 {
  margin-bottom: 0px;
  cursor: pointer;
}

.AttendeeCustomTable_searchcontainer__mlndk {
  display: flex;
  justify-content: end;
}

.AttendeeCustomTable_searchcontainer_inner__-CWtR {
  display: flex;
  justify-content: end;
  flex-direction: column;
}

.AttendeeCustomTable_attent_flex_contain__q1YYz {
  display: block;
}

.AttendeeCustomTable_attent_flex_contain__q1YYz h5 {
  margin: 20px 0px;
}

.AttendeeCustomTable_pay_btn__SUh-t {
  margin-right: 10px;
}

.AttendeeCustomTable_count_contain__JIQHT {
  display: flex;
  flex-direction: column;
}
.AttendeeCustomTable_count_contain__JIQHT .AttendeeCustomTable_totalamt1__Jpdbh {
  height: auto;
}

.AttendeeCustomTable_userhd__nkc\\+J {
  display: flex;
  justify-content: space-between;
}

@media only screen and (max-width: 1350px) {
  .AttendeeCustomTable_searchcontainer_inner__-CWtR {
    display: unset;
  }
}
@media only screen and (max-width: 768px) {
  .AttendeeCustomTable_Total_seat_count__z-M-N {
    font-size: 14px;
    font-weight: 700;
  }
  .AttendeeCustomTable_search_contain_box__OcQ1e {
    flex-direction: column;
  }
  .AttendeeCustomTable_search_contain_box1__DdZQY {
    flex-direction: column;
  }
  .AttendeeCustomTable_tabbtn__2KYu\\+ {
    flex-direction: column;
  }
}
@media only screen and (max-width: 600px) {
  .AttendeeCustomTable_totalamt1__Jpdbh ul {
    flex-direction: column;
  }
}
@media only screen and (max-width: 1250px) {
  .AttendeeCustomTable_search_contain_box1__DdZQY {
    flex-direction: column;
  }
}
@media only screen and (max-width: 767px) {
  .AttendeeCustomTable_search_contain_box__OcQ1e {
    flex-direction: column;
    margin-bottom: 20px;
  }
  .AttendeeCustomTable_search_contain_box__OcQ1e input {
    min-width: 100% !important;
    width: 100% !important;
  }
  .AttendeeCustomTable_search_contain__hxCOj {
    margin-bottom: 0px;
  }
  .AttendeeCustomTable_Total_count__KQSZL {
    flex-direction: column;
    justify-content: flex-start;
    align-items: baseline;
  }
  .AttendeeCustomTable_attent_flex_contain__q1YYz h5 {
    margin-bottom: 20px;
  }
}
@media only screen and (max-width: 600px) {
  #AttendeeCustomTable_dashboardcont2__fOe6q {
    width: calc(100% - 50px);
    left: 50px;
    position: relative;
    padding: 30px;
  }
  .AttendeeCustomTable_sectionright__VsLJr {
    gap: 0;
    flex-direction: column;
  }
}
tr:nth-child(even) {
  background-color: #fcfcfc;
}

.AttendeeCustomTable_onboardsty__v6x7b {
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: center;
}

@media screen and (max-width: 1230px) {
  .AttendeeCustomTable_onboardsty__v6x7b {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: center;
    align-items: center;
  }
  .AttendeeCustomTable_user_tb_hd__avwA4 {
    flex-direction: column;
    gap: 10px;
  }
}
.AttendeeCustomTable_count_box_contain__OTD6y {
  background-color: #fff;
  border-radius: 5px;
  padding: 30px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 50px;
}
@media screen and (max-width: 767px) {
  .AttendeeCustomTable_count_box_contain__OTD6y {
    gap: 15px;
  }
}
.AttendeeCustomTable_count_box_contain__OTD6y ul {
  padding: 0px;
  margin: 0px;
  display: flex;
  gap: 10px;
}
@media screen and (max-width: 767px) {
  .AttendeeCustomTable_count_box_contain__OTD6y ul {
    flex-wrap: wrap;
  }
}
@media screen and (max-width: 420px) {
  .AttendeeCustomTable_count_box_contain__OTD6y ul {
    padding: 0px;
    margin: 0px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }
}
.AttendeeCustomTable_count_box_contain__OTD6y ul li {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 20%;
}
@media screen and (min-width: 576px) and (max-width: 767px) {
  .AttendeeCustomTable_count_box_contain__OTD6y ul li {
    width: 33% !important;
  }
}
@media screen and (min-width: 420px) and (max-width: 576px) {
  .AttendeeCustomTable_count_box_contain__OTD6y ul li {
    width: 45% !important;
  }
}
@media screen and (max-width: 420px) {
  .AttendeeCustomTable_count_box_contain__OTD6y ul li {
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100% !important;
    justify-content: center;
    align-items: center;
  }
}
.AttendeeCustomTable_count_box_contain__OTD6y ul li .AttendeeCustomTable_count_text__chW1- {
  font-size: 16px;
  font-weight: 600;
  color: #727272;
}
@media screen and (max-width: 998px) {
  .AttendeeCustomTable_count_box_contain__OTD6y ul li .AttendeeCustomTable_count_text__chW1- {
    font-size: 14px !important;
  }
}
@media screen and (max-width: 1244px) {
  .AttendeeCustomTable_count_box_contain__OTD6y ul li .AttendeeCustomTable_count_text__chW1- {
    font-size: 12px;
  }
}
.AttendeeCustomTable_count_box_contain__OTD6y ul li .AttendeeCustomTable_count_num__IA57o {
  font-size: 22px;
  font-weight: 700;
  color: #131F43;
}
@media screen and (max-width: 998px) {
  .AttendeeCustomTable_count_box_contain__OTD6y ul li .AttendeeCustomTable_count_num__IA57o {
    font-size: 18px !important;
  }
}
@media screen and (max-width: 1244px) {
  .AttendeeCustomTable_count_box_contain__OTD6y ul li .AttendeeCustomTable_count_num__IA57o {
    font-size: 16px;
  }
}

.AttendeeCustomTable_export_btn__05vaH {
  font-size: 16px;
  font-weight: 600;
  color: #131F43;
  border: solid 1px #131F43;
  border-radius: 5px;
  background-color: transparent !important;
  display: flex;
  gap: 10px;
  border-color: #131F43 !important;
}

.AttendeeCustomTable_export_btn__05vaH svg {
  fill: #131F43;
}

.AttendeeCustomTable_export_btn__05vaH:hover {
  color: #fff;
  border: solid 1px #131F43;
  background-color: #131F43 !important;
}

.AttendeeCustomTable_export_btn__05vaH:hover svg {
  fill: #fff;
}

@media screen and (max-width: 1200px) {
  .AttendeeCustomTable_table_attendee__qMqyb th {
    min-width: auto;
  }
}
@media screen and (max-width: 767px) {
  .AttendeeCustomTable_table_attendee__qMqyb th {
    min-width: 150px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/components/AttendeeCustomTable/AttendeeCustomTable.module.scss"],"names":[],"mappings":"AAAA;;EAAA;AAkDA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,aAhBiB;EAiBjB,kBAAA;EACA,2BAAA;EACA,yBA1FO;EA2FP,gBAAA;EACA,kBAAA;ACvEF;;AD0EA;EACE,yBAAA;EACA,yBAjGO;EAkGP,kBAAA;ACvEF;;AD0EA;;;EAGE,yBApEoB;ACHtB;;AD0EA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACvEF;;AD0EA;;CAAA;AAIA;EACE,wBA1CU;EA2CV,UA1CS;EA2CT,kBAAA;EACA,aAlDiB;EAmDjB,kBAAA;EACA,mBA3HO;EA4HP,+BAAA;EACA,YAAA;EACA,2BAAA;EACA;;;GAAA;ACrEF;;AD2EA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ACxEF;;AD6EA;EACE,2BAAA;AC1EF;;AD6EA;EACE,yBAAA;EACA,YAAA;AC1EF;;AD8EA;EACE,YAAA;AC3EF;;AD8EA;EACE,sBA9GY;ACmCd;;AD8EA;;CAAA;AAGA;EACE,sBArHY;EAsHZ,iBAAA;AC3EF;;AD8EA;EACE,yBArIgB;EAsIhB,iBAAA;AC3EF;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;;CAAA;AAGA;EACE,sBAtIY;AC2Dd;;AD8EA;EACE,yBArJgB;AC0ElB;;AD8EA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;AC3EF;;AD8EA;;CAAA;AAGA;EACE,yBAAA;AC3EF;;AD8EA;EACE,yBA1KgB;AC+FlB;;AD8EA;;CAAA;AAGA;EACE,yBAAA;AC3EF;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;;EAEE,sBAAA;AC3EF;;AD8EA;EACE,yBA5LsB;EA6LtB,cAvMkB;AC4HpB;;AD8EA;EACE,sCAAA;EACA,sBAAA;EACA,oCAAA;AC3EF;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;EACE,sBAAA;EACA,oCAAA;AC3EF;;AD8EA;EACE,0BAAA;AC3EF;;AD8EA;EACE,uBAAA;AC3EF;;AD8EA;EACE,0BAAA;AC3EF;;AD8EA;EACE,uBAAA;AC3EF;;AD8EA;;EAEE,qBAAA;AC3EF;;AD8EA;EACE,yBArOsB;EAsOtB,WA7NY;ACkJd;;AD8EA;;CAAA;AAGA;EACE,cAjOe;ACsJjB;;AD8EA;EACE,cArOe;AC0JjB;;AD8EA;;CAAA;AAGA;EACE,sBA/OY;EAgPZ,YAAA;AC3EF;;AD8EA;EACE,yBA/PgB;EAgQhB,WArPY;EAsPZ,YAAA;AC3EF;;AD8EA;EACE,cAvPe;AC4KjB;;AD8EA;;CAAA;AAGA;EACE,yBA9Sc;EA+Sd,8BAAA;AC3EF;;AD8EA;EACE,WAtQY;AC2Ld;;AD8EA;;EAEE,0BAAA;AC3EF;;AD8EA;;EAEE,0BAAA;AC3EF;;AD8EA;EACE,kBAAA;AC3EF;;AD8EA;EACE,kBAAA;AC3EF;;AD8EA;EACE,oCAAA;EACA,gCAAA;AC3EF;;AD8EA;EACE,yBAzRkB;EA0RlB,WAlSY;ACuNd;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;EACE,iBAAA;AC3EF;;AD8EA;;EAEE,+BAAA;EACA,iBAAA;AC3EF;;AD8EA;EACE,sBApTY;ACyOd;AD6EE;EACE,sBAvTU;EAwTV,YAAA;AC3EJ;AD6EE;EACA,iBAAA;AC3EF;;ADgFA;EACE,0CAAA;EACA,cA/Te;ACkPjB;AD+EE;EACE,yCAAA;EACA,eAAA;AC7EJ;;ADiFA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC9EF;;ADiFA;EACE,yBAAA;EACA,0BAAA;AC9EF;;ADiFA;;CAAA;AAGA;EACE,sBA3VY;EA4VZ,yBAAA;EACA,qDAAA;AC9EF;;ADiFA;EACE,yBAzVkB;EA0VlB,yBAAA;EACA,eAAA;AC9EF;ADgFE;EACE,cAnWa;ACqRjB;;ADmFA;;CAAA;AAGA;EACE,yBAlXgB;ACkSlB;;ADmFA;EACE,yBAAA;EACA,yBAAA;AChFF;;ADmFA;EACE,yBAlYoB;EAmYpB,yBAAA;AChFF;;ADmFA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AChFF;;ADmFA;;CAAA;AAGA;EACE,sBAtYY;ACsTd;;ADmFA;EACE,yBAlYkB;ACkTpB;;ADoFA;;CAAA;AAGA;EACE,iGAAA;EACA,sBAnZY;ACkUd;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;EACE,gGAAA;EACA,sBA5ZY;AC2Ud;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;EACE,gGAAA;EACA,sBAraY;ACoVd;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;EACE,gGAAA;EACA,sBA9aY;AC6Vd;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;;;;;;;;EAQE,WA7bY;AC4Wd;;ADoFA;;CAAA;AAGA;EACE,qCAAA;ACjFF;;ADoFA;EACE,cArce;ACoXjB;;ADqFA;;CAAA;AAGA;EACE,sBAAA;AClFF;;ADqFA;EACE,yBAAA;AClFF;;ADqFA;EACE,yBAzekB;EA0elB,WAzdY;ACuYd;;ADqFA;EACE,yBA9ekB;EA+elB,WA9dY;AC4Yd;;ADqFA;EACE,6BAAA;AClFF;;ADqFA;EACE,2BAAA;AClFF;;ADqFA;EACE,yBA3fkB;ACyapB;;ADqFA;EACE,yBA9fwB;AC4a1B;;ADqFA;EACE,WAlfY;EAmfZ,6BAAA;EACA,yBAAA;AClFF;;ADqFA;EACE,yBAzgBkB;ACubpB;;ADsFA;EACE,yBAxgBgB;ACqblB;;ADsFA;EACE,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,wCAAA;EACA,oCAAA;EACA,yBAAA;EACA,2BAAA;ACnFF;;ADsFA;;;EAGE,oCAAA;EACA,sBAAA;ACnFF;;ADsFA;EACE,gBAAA;EACA,YAAA;EACA,WAphBY;EAqhBZ,yBAhjBY;EAijBZ,YAAA;EACA,eAAA;EACA,gBA3kBc;ACwfhB;;ADsFA;EACE,gBAAA;EACA,YAAA;EACA,WA9hBY;EA+hBZ,yBA1jBY;EA2jBZ,YAAA;EACA,eAAA;EACA,gBArlBc;ACkgBhB;;ADsFA;EACE,yBAjkBY;AC8ed;;ADsFA;EACE,yBA3jBkB;ACwepB;;ADsFA;EACE,yBA9jBwB;AC2e1B;;ADsFA;EACE,cApkBiB;ACifnB;;ADuFA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACpFF;;ADuFA;EACE,WA7jBY;EA8jBZ,yBAzlBY;EA0lBZ,YAAA;ACpFF;;ADuFA;EACE,QAAA;ACpFF;;ADuFA;EACE,gBAAA;EACA,YAAA;EACA,yBA7lBW;EA8lBX,WA1kBY;EA2kBZ,eAAA;EACA,gBA/nBc;EAgoBd,YAAA;ACpFF;;ADuFA;EACE,gBAAA;EACA,YAAA;EACA,yBAvmBW;EAwmBX,WAplBY;EAqlBZ,eAAA;EACA,gBAzoBc;EA0oBd,YAAA;ACpFF;;ADuFA;;EAEE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACpFF;;ADuFA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACpFF;;ADuFA;;;EAGE,yBA9nBW;EA+nBX,WA3mBY;EA4mBZ,YAAA;ACpFF;;ADuFA;EACE,oCAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;ACpFF;;ADuFA;;;EAGE,oCAAA;ACpFF;;ADuFA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACpFF;;ADyFA;EACE,aAAA;EACA,kBAAA;ACtFF;;ADyFA;EACE,mBAAA;ACtFF;;ADyFA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;ACtFF;;ADyFA;EACE,UAAA;ACtFF;;ADyFA;EACE,yCA3qBc;EA4qBd,cAhrBkB;AC0lBpB;;ADyFA;EACE,aAprBkB;AC8lBpB;;ADyFA;EACE,yBAhrBgB;AC0lBlB;;ADyFA;EACE,yBAAA;ACtFF;;ADyFA;EACE,6BAAA;EACA,yBAAA;EACA,WA/qBY;ACylBd;;ADyFA;;EAEE,yBArsBkB;EAssBlB,WArrBY;AC+lBd;;ADyFA;EACE,6BAAA;EACA,yBAAA;EACA,WA3rBY;ACqmBd;;ADyFA;EACE,yBAxsBsB;EAysBtB,WAhsBY;AC0mBd;;ADyFA;;;EAGE,WAtsBY;ACgnBd;;ADyFA;;EAEE,yBAttBgB;EAutBhB,WA5sBY;ACsnBd;;ADyFA;EACE,yBA9vBO;ACwqBT;;ADyFA;EACE,eA/tBgB;ACyoBlB;;ADyFA;EACE,YAxtBY;ACkoBd;;ADyFA;;EAEE,sBAAA;ACtFF;;ADyFA,iBAAA;AAKA;EACE,mBAAA;EACA,gBAAA;AC1FF;;AD6FA;EACE,0BAAA;AC1FF;;AD6FA;EACE,2BAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,uBAAA;AC1FF;;AD6FA;EACE,qBAAA;EACA,iCAAA;EACA,cAAA;AC1FF;;AD6FA;EACE,6BAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;AC1FF;;AD6FA;EACE,cAAA;EACA,WAAA;EACA,0CAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,oEAAA;AC1FF;;AD6FA;;EAEE,0BAAA;EACA,aAAA;AC1FF;;AD6FA;EACE,kBAAA;EACA,kBAAA;AC1FF;;AD6FA;EACE;IACE,gBAAA;EC1FF;AACF;AD6FA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,6BAAA;EC3FF;ED8FA;IACE,uBAAA;IACA,+BAAA;EC5FF;AACF;AD+FA;EACE;;IAAA;AC3FF;ADgGA;EACE;IACE,uBAAA;EC9FF;EDiGA;IACE,6BAAA;EC/FF;AACF;ADkGA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,kCAAA;EChGF;EDmGA;;IAEE,kBAAA;ECjGF;EDoGA;IACE,eAAA;EClGF;EDqGA;IACE,aAAA;ECnGF;EDsGA;IACE,8BAAA;IACA,aAAA;ECpGF;AACF;ADuGA;EACE;IACE,iBAAA;ECrGF;EDwGA;IACE,gBAAA;ECtGF;EDyGA;;KAAA;ACrGF;AD0GA,mBAAA;AAGE;EACE,iCAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AC1GJ;AD2GI;EAPF;IAQI,gBAAA;ECxGJ;AACF;AD2GE;EACE,WAAA;EACA,cAAA;ACzGJ;AD2GI;EACE,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;ACzGN;AD0GM;EAPF;IAQI,iBAAA;IACA,aAAA;IACA,iBAAA;ECvGN;AACF;ADwGM;EACE,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;ACtGR;AD0GI;EACE,WAAA;EACA,cAAA;ACxGN;ADyGA;EACE,cAAA;ACvGF;ADyGM;EACE,WAAA;EACA,mBAAA;ACvGR;ADyGQ;EACE,uEAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;ACvGV;AD0GQ;EACE,kFAAA;ACxGV;AD6GM;EACE,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,SAAA;AC3GR;AD8GM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AC5GR;AD8GQ;EACE,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AC5GV;AD+GQ;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;AC7GV;;ADoHA,mBAAA;AACA;EACI,2BAAA;ACjHJ;;ADoHE;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;EACA,mBAAA;ACjHJ;ADmHI;EATF;IAUI,yBAAA;EChHJ;AACF;ADkHI;EAbF;IAcI,aAAA;IACA,SAAA;IACA,kBAAA;EC/GJ;AACF;ADkHM;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;AChHR;ADoHI;EACE,SAAA;AClHN;ADoHM;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AClHR;ADoHQ;EALF;IAMI,kBAAA;IACA,qBAAA;IACA,WAAA;ECjHR;AACF;ADmHQ;EACE,SAAA;EACA,UAAA;ACjHV;ADmHU;EAJF;IAKI,gCAAA;IACA,sBAAA;EChHV;AACF;ADkHU;EATF;IAUI,mBAAA;IACA,WAAA;IACA,eAAA;IACA,UAAA;IACA,mBAAA;EC/GV;AACF;ADiHU;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AC/GZ;ADkHU;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AChHZ;ADqHM;EACE,6BAAA;ACnHR;ADoHQ;EACE,iBAAA;AClHV;ADmHU;EACE,WAAA;ACjHZ;ADkHY;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AChHd;;ADyHC;EACK,aAAA;EACF,2BAAA;EACA,MAAA;EACA,mBAAA;EACA,eAAA;ACtHJ;ADuHI;EANH;IAOK,uBAAA;ECpHJ;AACF;;ADsHA;EACE,gBAAA;ACnHF;ADqHE;EACE,iBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;ACnHJ;ADqHI;EARF;IASI,kBAAA;EClHJ;AACF;ADmHI;EAXF;IAYI,iBAAA;IACA,uBAAA;EChHJ;AACF;ADkHI;EACE,iBAAA;EACA,YAAA;EACA,WAAA;AChHN;ADkHM;EALF;IAMI,4BAAA;EC/GN;AACF;ADkHI;EACE,4BAAA;AChHN;ADoHE;EACE,YAAA;EACA,mBAAA;EACA,cAAA;AClHJ;ADoHI;EALF;IAMI,uBAAA;ECjHJ;AACF;ADmHI;EACE,iBAAA;EACA,YAAA;EACA,WAAA;ACjHN;ADmHM;EALF;IAMI,4BAAA;EChHN;AACF;ADkHI;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AChHN;ADiHM;EARF;IASI,eAAA;EC9GN;AACF;;ADqHA;EACE,yCAAA;EACA,SAAA;EACA,mBAAA;AClHF;ADoHE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;AClHJ;;AAzlCA;EACE,YAAA;AA4lCF;;AAzlCA;EACI,eAAA;EACA,gBAAA;AA4lCJ;;AAzlCA;EACE,kBAAA;AA4lCF;;AAzlCA;EACE,wBAAA;AA4lCF;;AAzlCA;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,cD0CiB;ACkjCnB;;AAzlCA;EACE,0BAAA;AA4lCF;;AAzlCA;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,yBD+Be;EC9Bf,kBAAA;EACA,WDgBU;ECfV,gBAAA;EACA,mBAAA;EACA,eAAA;AA4lCJ;AA1lCI;EACE,2CDwBe;ACokCrB;;AAxlCA;EACI,oCAAA;EACA,gCAAA;AA2lCJ;;AAvlCA;;EAEI,0BAAA;AA0lCJ;;AAtlCA;;EAEI,0BAAA;AAylCJ;;AAtlCA;EACE,aAAA;AAylCF;;AAvlCE;EACE,eAAA;AA0lCJ;;AArlCE;EACE,+BAAA;AAwlCJ;;AArlCE;EACE,+BAAA;EACA,iBAAA;AAwlCJ;;AA5kCA;EACE,YAAA;EACA,gBAAA;EACA,cAAA;AA+kCF;;AA5kCA;EACI,eAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;AA+kCJ;;AA5kCA;EACE,WAAA;AA+kCF;;AA3kCE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AA8kCJ;;AA5kCE;EACE,kBAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AA+kCJ;;AA5kCA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AA+kCF;;AA5kCA;EACE,cAAA;AA+kCF;;AA5kCA;EACE,cAAA;AA+kCF;;AA5kCA;EACE,cAAA;AA+kCF;;AA5kCA;EACE,kBAAA;AA+kCF;;AA5kCA;EACE,UAAA;EACA,6BAAA;EACA,YAAA;AA+kCF;;AA5kCA;EACE,6BAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;AA+kCF;;AA5kCA;EACE,6BAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;AA+kCF;;AA5kCA;EACE,6BAAA;EACA,YAAA;EACA,2BAAA;EACA,aAAA;AA+kCF;;AA3kCA;EACE,kBAAA;EACA,qBAAA;EACA,+BAAA;AA8kCF;;AA3kCA;EACE,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AA8kCF;;AA1kCA;EACE,mBAAA;AA6kCF;;AA1kCA;EACE,aAAA;EACA,SAAA;EACA,8BAAA;EACA,mBAAA;AA6kCF;AA5kCE;EALF;IAMI,sBAAA;IACA,mBAAA;EA+kCF;AACF;;AA7kCA;EACE,aAAA;EACA,SAAA;EACA,8BAAA;EACA,cAAA;AAglCF;;AA9kCA;EACE,aAAA;EACA,SAAA;AAilCF;;AA/kCA;EACE,aAAA;EACF,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,iCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;AAklCA;;AA/kCA;EACE,4BAAA;EACF,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAklCA;;AAhlCA;EACE,aAAA;EACF,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,iCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;AAmlCA;;AAhlCA;EACE,oBAAA;EACA,qBAAA;AAmlCF;;AAjlCA;EACE,gBAAA;EACA,aAAA;EACA,SAAA;EACA,qBAAA;EACA,SAAA;AAolCF;;AAjlCA;EACA,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAolCA;;AAllCA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AAqlCF;;AAllCA;EACE,eAAA;EACA,gBAAA;AAqlCF;;AAllCA;EACE,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAqlCF;;AAllCA;EACE,aAAA;EACA,SAAA;EACA,sBAAA;EACA,8BAAA;AAqlCF;AAplCE;EALF;IAMI,sBAAA;EAulCF;AACF;AAtlCE;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,4BAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;EACA,YAAA;AAwlCJ;AAtlCI;EAVF;IAWI,sBAAA;IACA,YAAA;EAylCJ;AACF;AAxlCI;EAdF;IAeE,kBAAA;IACA,4BAAA;IACA,aAAA;IAEA,SAAA;IACA,mBAAA;IACA,YAAA;EA0lCF;AACF;AAtlCI;EACE,aAAA;EACA,SAAA;AAwlCN;AAvlCM;EAHF;IAII,sBAAA;EA0lCN;AACF;AAzlCM;EANF;IAOI,aAAA;IACJ,QAAA;IACA,sBAAA;EA4lCF;AACF;AA1lCI;EACE,WAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA4lCN;AA3lCQ;EALJ;IAMM,kBAAA;EA8lCR;AACF;AA5lCI;EACE,aAAA;EACA,6BAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;AA8lCN;AA7lCM;EACE,cAAA;AA+lCR;AA7lCM;EACE,aAAA;EACA,YAAA;EACA,gBAAA;AA+lCR;;AAzlCA;EACE,YAAA;EACA,aAAA;EACA,SAAA;AA4lCF;AA1lCE;EACE,0BAAA;AA4lCJ;AA1lCE;EACI,yBD1Ta;EC2Tb,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AA4lCN;AA1lCE;EACI,eAAA;AA4lCN;AAzlCE;EACE,eAAA;EACA,gBAAA;AA2lCJ;;AAvlCA;EACE,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,kCAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AA0lCF;;AAtlCA;EACE,iBAAA;EACF,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AAylCA;;AAtlCA;EACE,iBAAA;EACF,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kCAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AAylCA;;AAtlCA;EACE,kBAAA;EACA,eAAA;AAylCF;;AAtlCA;EACE,aAAA;EACA,oBAAA;AAylCF;;AAtlCA;EACI,aAAA;EACA,oBAAA;EACA,sBAAA;AAylCJ;;AAtlCA;EACE,cAAA;AAylCF;;AAtlCA;EACE,gBAAA;AAylCF;;AAtlCA;EACE,kBAAA;AAylCF;;AAtlCA;EACE,aAAA;EACA,sBAAA;AAylCF;AAxlCE;EACE,YAAA;AA0lCJ;;AAtlCA;EACE,aAAA;EACA,8BAAA;AAylCF;;AArlCA;EACE;IACE,cAAA;EAwlCF;AACF;AArlCA;EACE;IACE,eAAA;IACA,gBAAA;EAulCF;EArlCA;IACA,sBAAA;EAulCA;EArlCF;IACC,sBAAA;EAulCC;EArlCF;IACE,sBAAA;EAulCA;AACF;AArlCA;EACA;IACE,sBAAA;EAulCA;AACF;AArlCA;EAEA;IACC,sBAAA;EAslCC;AACF;AAnlCA;EACE;IACE,sBAAA;IACA,mBAAA;EAqlCF;EAnlCA;IACE,0BAAA;IACA,sBAAA;EAqlCF;EAnlCA;IACE,kBAAA;EAqlCF;EAnlCA;IACE,sBAAA;IACA,2BAAA;IACA,qBAAA;EAqlCF;EAnlCA;IACE,mBAAA;EAqlCF;AACF;AAnlCA;EACE;IACI,wBD/cM;ICgdN,UD/cK;ICgdL,kBAAA;IACA,aDvda;EC4iDjB;EAnlCA;IACE,MAAA;IACA,sBAAA;EAqlCF;AACF;AAnlCC;EACC,yBAAA;AAqlCF;;AAllCA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,uBAAA;AAqlCF;;AAllCA;EACE;IACA,aAAA;IACA,eAAA;IAEA,SAAA;IACA,uBAAA;IACA,mBAAA;EAolCA;EA/kCF;IACE,sBAAA;IACA,SAAA;EAilCA;AACF;AA5kCA;EACE,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AA8kCF;AA7kCE;EARF;IASM,SAAA;EAglCJ;AACF;AA/kCE;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,SAAA;AAilCJ;AAhlCI;EALF;IAMI,eAAA;EAmlCJ;AACF;AAllCI;EARF;IASE,YAAA;IACA,WAAA;IACA,aAAA;IACA,8BAAA;IACA,sBAAA;IACA,mBAAA;IACA,SAAA;EAqlCF;AACF;AAnlCI;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;AAqlCN;AAplCO;EANH;IAOI,qBAAA;EAulCN;AACF;AAtlCO;EATH;IAUI,qBAAA;EAylCN;AACF;AAxlCM;EAZF;IAaA,gBAAA;IACA,aAAA;IACA,sBAAA;IACA,SAAA;IACA,sBAAA;IACA,uBAAA;IACJ,mBAAA;EA2lCE;AACF;AA1lCM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AA4lCR;AA3lCQ;EAJF;IAKI,0BAAA;EA8lCR;AACF;AA7lCQ;EAPF;IAQI,eAAA;EAgmCR;AACF;AA9lCM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAgmCR;AA/lCS;EAJH;IAKI,0BAAA;EAkmCR;AACF;AAjmCQ;EAPF;IAQI,eAAA;EAomCR;AACF;;AA9lCA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,wCAAA;EACA,aAAA;EACA,SAAA;EACA,gCAAA;AAimCF;;AA9lCA;EACE,aAAA;AAimCF;;AA7lCA;EACE,WAAA;EACA,yBAAA;EACA,oCAAA;AAgmCF;;AA7lCA;EACE,UAAA;AAgmCF;;AA3lCI;EADF;IAEI,eAAA;EA+lCJ;AACF;AA9lCI;EAJF;IAKI,gBAAA;EAimCJ;AACF","sourcesContent":["/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #131F43;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #F3F4F8;\n$cardIcon1-darkbg: #30231a;\n$cardIcon1-darkbg-icon: #9d785f;\n$cardIcon2-bg: #FAF4FB;\n$cardIcon2-darkbg: #13252a;\n$cardIcon2-darkbg-icon: #3b606a;\n$cardIcon3-bg: #FAF7F3;\n$cardIcon3-darkbg: #2c1a27;\n$cardIcon3-darkbg-icon: #6c4863;\n$cardIcon4-bg: #F5F9FC;\n$cardIcon4-darkbg: #241d3e;\n$cardIcon4-darkbg-icon: #5f538b;\n$cardIcon2-color: #AC44BB;\n$cardIcon3-color: #D69A5F;\n$cardIcon4-color: #176CA5;\n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n$dark-active-blue : #3b82f6;\n$dark-light-blue : #92afd3;\n$addBtn-dark-blue : #3b82f6;\n$addBtn-dark-blue-hover : #2563eb;\n$backBtn-dark : #3b82f633;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #132337;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #131F43;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 290px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: $mainBg;\n  overflow-y: auto;\n  padding-right: 0px;\n}\n\n.dashboardContain {\n  width: calc(100% - 320px);\n  background-Color: $mainBg;\n  border-radius: 8px;\n}\n\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard,\n.bodythemedark .cont2 {\n  background-Color: $darkTheme_darkBlue;\n}\n\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  /*height: calc(100vh - 160px);*/\n  height: 100%;\n  min-height: auto !important;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n.subLink svg {\n  position: relative;\n  top: -2px;\n  left: -7px;\n}\n\n\n\n.cst_vendr input {\n  min-height: 35px !important;\n}\n\n.cst_vendr .form-control {\n  background-color: #f5f6fa;\n  border: none;\n}\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n.bodythemeNew {\n  background-color: #f5f6fa;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 2;\n  top: 0;\n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: #f5f6fa;\n}\n\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span,\n.menulinklight:hover a {\n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $dark-active-blue;\n}\n\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color !important;\n}\n\n.menulinkdark {\n  color: $dark-light-blue !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color !important;\n}\n\n.menulinklight .sub_arrow svg path {\n  stroke: $menu_icon !important;\n}\n\n.menulinklight:hover .sub_arrow svg path {\n  stroke: $white-color !important;\n}\n\n.menulinkdark .sub_arrow svg path {\n  stroke: $dark-light-blue !important;\n}\n\n.menulinkdark:hover .sub_arrow svg path {\n  stroke: $white-color !important;\n}\n\n.menulinklight:hover svg path,\n.menulinklightSelected svg path {\n  fill: #fff !important;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n\n.tableheadlight th {\n  color: $white-color;\n}\n\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n}\n\nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child {\n  border-radius: 0 5px 0px 0;\n}\n\nth:first-child {\n  border-radius: 0px;\n}\n\ntd:last-child {\n  border-radius: 0px;\n}\n\ntable.table.table-borderless {\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n\n.tablebodylight td,\n.tablebodydark td {\n  padding: 0.5rem 1rem !important;\n  line-height: 45px;\n}\n\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: $white-color;\n    cursor: auto;\n  }\n  p{\n  line-height: 24px;\n}\n\n}\n\n.tablebodydark {\n  /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: pointer;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n\n.permissionboxdark {\n  background-color: $darkTheme_darkBlue;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a,\n#card1bgdark p,\n#card2bgdark a,\n#card2bgdark p,\n#card3bgdark a,\n#card3bgdark p,\n#card4bgdark a,\n#card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n#addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important;\n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $addBtn-dark-blue;\n}\n\n.bodythemedark .formbtn:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $addBtn-dark-blue;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border-radius: 5px !important;\n  background-color: transparent !important;\n  border: solid 1px $primary-color !important;\n  color: $primary-color !important;\n  min-width: 113px !important;\n}\n\n.resetbtn:hover,\n.resetbtn:active,\n.resetbtn:focus {\n  background-color: $primary-color !important;\n  color: $white-color !important;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addDltBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addbtnlight {\n  background-color: $green-color;\n}\n\n.addbtndark {\n  background-color: $addBtn-dark-blue;\n}\n\n.addbtndark:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.formthemedark label {\n  color: $dark-light-blue;\n}\n\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn:active,\n.deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important;\n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover,\n.deleteBtn:active,\n.deleteBtn:focus {\n  background-color: $red-color;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color !important;\n  min-width: 130px !important;\n  height: 50px !important;\n  color: $white-color !important;\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border: none !important;\n}\n\n.confirmBtn:hover,\n.confirmBtn:active,\n.confirmBtn:focus {\n  background-color: $darkTheme_darkBlue !important;\n}\n\n.confirmBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n\n\n.delPopContainer .modal-body {\n  padding: 35px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n  padding: 0 20px;\n}\n\n.arrowback svg {\n  fill: #000;\n}\n\n.bodythemedark .arrowback {\n  background-color: $backBtn-dark;\n  color: $dark-active-blue;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $dark-active-blue;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $dark-light-blue !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral,\n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a,\n.headerthemedark .dropdown_menu_contain .dropdown_item,\n.headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a:hover,\n.headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n}\n\n.dropdown_item:active {\n  background-color: $mainBg;\n}\n\n.profile_arrrow_dwn {\n  stroke: $darkTheme_blue;\n}\n\n.headerthemedark .profile_arrrow_dwn {\n  stroke: $white-color;\n}\n\n.dateinputbox1 input,\n.dateinputbox1 span {\n  color: $white-color !important;\n}\n\n/* LOGOUT MODAL */\n.modalStyleLight {}\n\n.modalStyleDark {}\n\n.delPopContainer .modal-content {\n  border-radius: 10px;\n  min-width: 399px;\n}\n\n.larg_model .modal-dialog {\n  max-width: 100% !important;\n}\n\n.larg_model .modal-content {\n  /* display: inline-block; */\n  height: 100%;\n  max-width: 900px;\n  margin: auto;\n  border-radius: 54px !important;\n  background: #FFF;\n  padding: 53px 53px 23px;\n}\n\n.larg_model .modal-header {\n  padding: 0px 0px 23px;\n  border-bottom: 1px dashed #D4D9EE;\n  display: block;\n}\n\nbody .btn-primary:hover {\n  background-color: transparent;\n  border-color: #131F43;\n  color: #131F43;\n  fill: #131F43;\n  border: 1px solid;\n}\n\n.form-select {\n  display: block;\n  width: 100%;\n  padding: .375rem 2.25rem .375rem .75rem;\n  -moz-padding-start: calc(0.75rem - 3px);\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #212529;\n  background-color: #fff;\n  background-image: url(../../assets/select_arow.svg) !important;\n}\n\nthead .CustomTable_tableheadlight__HuHZw th:first-child,\nthead .CustomTable_tableheaddark__nwqb4 th:first-child {\n  border-radius: 5px 0 0 0px;\n  display: math;\n}\n\nth:first-child {\n  border-radius: 0px;\n  position: absolute;\n}\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 270px;\n  }\n}\n\n@media only screen and (max-width: 1024px) {\n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n    overflow-x: hidden !important;\n  }\n\n  .cont2 {\n    height: auto !important;\n    padding-bottom: 10px !important;\n  }\n}\n\n@media only screen and (max-width: 998px) {\n  /* #dashboardcont2{\n    height: auto !important;\n  }*/\n}\n\n@media only screen and (max-width: 767px) {\n  .sectionright {\n    float: unset !important;\n  }\n\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 10px 10px 15px !important;\n  }\n\n  .bodythemelight,\n  .bodythemedark {\n    padding-top: 110px;\n  }\n\n  .delPopContainer .modal-content {\n    min-width: 100%;\n  }\n\n  .delPopContainer .modal-body {\n    padding: 15px;\n  }\n\n  .larg_model .modal-content {\n    border-radius: 20px !important;\n    padding: 22px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n    max-width: 1055px;\n  }\n\n  .delPopContainer .modal-dialog {\n    max-width: 350px;\n  }\n\n  /*.tableheadlight th {\n    min-width: 120px;\n  } */\n}\n\n/* vk new changes */\n.active_show_outer {\n\n  h2 {\n    color: var(--Font-black, #0B0D0F);\n    font-family: Urbanist;\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    @media screen and (max-width:768px) {\n      margin-top: 15px;\n    }\n  }\n\n  .active_show_inner {\n    width: 100%;\n    display: block;\n\n    .act_box_img {\n      margin-bottom: 12px;\n      min-height: 400px;\n      object-fit: cover;\n      overflow: hidden;\n      height: 400px;\n      max-height: 400px;\n      @media (max-width: 767px) {\n        min-height: 300px;\n        height: 300px;\n        max-height: 300px;\n      }\n      img {\n        max-height: 400px;\n        /* align-self: stretch; */\n        width: 100%;\n        height: 100%;\n        border-radius: 12px;\n        object-fit: cover;\n      }\n    }\n\n    .act_box_cnt {\n      width: 100%;\n      display: block;\nsvg{\n  flex-shrink: 0;\n}\n      .act_box_bdg {\n        width: 100%;\n        margin-bottom: 12px;\n\n        span {\n          background: url(../../assets/ongoing.png) right top no-repeat;\n          width: 111px;\n          display: block;\n          height: 34px;\n          color: var(--White, #FFF);\n          font-size: 18px;\n          font-style: normal;\n          font-weight: 500;\n          padding: 3px 8px;\n        }\n\n        .sold {\n          background: url(../../assets/sold.png) right top no-repeat !important;\n        }\n\n      }\n\n      h3 {\n        color: var(--Secondary, #132941);\n        font-size: 18px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 26.304px;\n        margin: 0;\n      }\n\n      p {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        margin-bottom: 5px;\n\n        span {\n          color: var(--Light-1, #736B66);\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 500;\n          line-height: 26.304px;\n        }\n\n        .timezone_code_pill {\n          display: inline-block;\n          padding: 2px 8px;\n          margin-left: 4px;\n          background: #e0f2fe;\n          color: #0369a1;\n          font-size: 12px;\n          font-weight: 600;\n          letter-spacing: 0.02em;\n          border-radius: 6px;\n        }\n      }\n    }\n  }\n}\n\n/* vk new changes */\n#attent_details_row1{\n    margin-bottom: 0 !important;\n}\n.attent_details {\n  .attent_details_inner {\n    display: flex;\n    gap: 61px;\n    padding: 20px;\n    border-radius: 5px;\n    background: #FFF;\n    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);\n    align-items: center;\n\n    @media (max-width: 576px) {\n      display: block !important;\n    }\n\n    @media (max-width: 992px) {\n      display: flex;\n      gap: 20px;\n      align-items: start;\n    }\n\n    .attent_details_inner_l {\n      img {\n        width: 187px;\n        height: 207px;\n        flex-shrink: 0;\n        object-fit: cover;\n      }\n    }\n\n    .attent_details_inner_r {\n      flex: 1;\n\n      .attent_details_row {\n        display: flex;\n        gap: 20px;\n        margin-bottom: 28px;\n\n        @media (max-width: 992px) {\n          margin-bottom: 0px;\n          display: inline-block;\n          width: 100%;\n        }\n\n        .attent_details_row_box {\n          flex: 1;\n          width: 22%;\n\n          @media (max-width: 576px) {\n            margin: 15px 0px 10px !important;\n            width: 100% !important;\n          }\n\n          @media (max-width: 992px) {\n            margin-bottom: 15px;\n            float: left;\n            margin-right: 0;\n            width: 50%;\n            padding-right: 10px;\n          }\n\n          p {\n            margin-bottom: 10px;\n            color: #727272;\n            font-size: 13px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: normal;\n          }\n\n          h5 {\n            color: #131F43;\n            font-size: 16px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: normal;\n            word-wrap: break-word;\n          }\n        }\n      }\n\n      .attent_details_row_last {\n        margin-bottom: 0px !important;\n        &.interesting_fact {\n          padding-top: 30px;\n          .attent_details_row_box {\n            width: 100%;\n            h5 {\n              color: #131F43;\n              font-size: 16px;\n              font-style: normal;\n              font-weight: 500;\n              line-height: 24px;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n .showbox_sec{\n      display: flex;\n    justify-content: flex-start;\n    gap: 0;\n    flex-direction: row;\n    flex-wrap: wrap;\n    @media screen and (max-width:500px) {\n      justify-content: center;\n    }\n }\n.show_box_main {\n  margin: 10px 0px;\n\n  .show_box {\n    min-height: 600px;\n    width: 300px;\n    float: left;\n    margin-right: 20px;\n    margin-bottom: 20px;\n    cursor: pointer;\n\n    @media (max-width: 1024px) {\n      margin-right: 18px;\n    }\n    @media (max-width: 767px) {\n      min-height: 500px;\n      width: 200px !important;\n    }\n\n    img {\n      max-height: 400px;\n      height: 100%;\n      width: 100%;\n\n      @media (max-width: 767px) {\n        max-height: 300px !important;\n      }\n    }\n\n    &:last-child {\n      margin-right: 0px !important;\n    }\n  }\n\n  .no_show_box {\n    width: 350px;\n    margin: 0 auto 20px;\n    display: block;\n  \n    @media (max-width: 767px) {\n      width: 250px !important;\n    }\n  \n    img {\n      max-height: 450px;\n      height: 100%;\n      width: 100%;\n  \n      @media (max-width: 767px) {\n        max-height: 350px !important;\n      }\n    }\n    h6 {\n      color: #000;\n      text-align: center;\n      font-size: 26px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n      margin-top: 20px;\n      @media only screen and (max-width: 600px) {\n        font-size: 20px;\n      }\n    }\n  }\n  \n\n}\n\n.attent_flex {\n  justify-content: space-between !important;\n  gap: 30px;\n  align-items: center;\n\n  h5 {\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 700;\n  }\n}","@import \"/src/styles/Variables/Variables.scss\";\n\n\n#container{\n  padding: 0px;\n}\n\n#tableheading{\n    font-size: 16px;\n    margin-top: 20px;\n  }\n\n.search_box{\n  position: relative;\n}\n \nthead .CustomTable_tableheadlight__HuHZw th:first-child, thead .CustomTable_tableheaddark__nwqb4 th:first-child {\n  display: math !important;\n}\n\n#spinner{\n  float: right;\n  margin-top: -25px;\n  position: relative;\n  z-index: 1;\n  margin-right: 10px;\n  cursor: pointer;\n  color: $primary-btncolor;\n}\n\n.tbl_sl {\n  min-width: 10px !important;\n}\n\n.tablebtn{\n    width: 70px;\n    padding: 6px;\n    border:  none;\n    background-color: $primary-btncolor;\n    border-radius: 5px;\n    color: $white-color;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    font-size: 14px;\n\n    &:hover{\n      background-color: $secondary-btncolor;\n    }\n  }\n\ntable{\n    border-collapse:separate !important;\n    border-spacing:0 6px !important;\n  }\n\n// Set border-radius on the top-left and bottom-left of the first table data on the table row\ntd:first-child,\nth:first-child {\n    border-radius: 8px 0 0 8px;\n  }\n\n// Set border-radius on the top-right and bottom-right of the last table data on the table row\ntd:last-child,\nth:last-child {\n    border-radius: 0 8px 8px 0;\n  }\n  \n.tableheaddiv{\n  display: flex;\n}\n  th,td{\n    font-size: 14px;\n     \n     \n  }\n\n  th{\n    padding: 0.8rem 1rem !important;\n  }\n\n  td{\n    padding: .5rem 1rem !important;\n    line-height: 28px;\n  }\n\n\n\n// .order_date{\n//     margin-top: 5px;\n//     font-size: 12px;\n//     color: #898989;\n//     font-weight: normal;\n//   }\n\n.sortbtn{\n  border: none;\n  background: none;\n  color: #6E6E6E;\n  }\n\n.order_date{\n    margin-top: 5px;\n    font-size: 12px;\n    color:#000;\n    font-weight: normal;\n  }\n\nh6{\n  color: #000;\n  }\n\n  \n  .norecord {\n    font-size: 22px;\n    margin-top: 10px;\n    color: #939090;\n  }\n  .norecordsdiv{\n    position: absolute;\n    left: 42%;\n    margin-top: 2%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n  \n.ststus_text {\n  font-size: 14px;\n  font-weight: 600;\n  padding-left: 8px;\n}\n\n.ststus_not_verified {\n  color: #9f9e9d;\n}\n\n.ststus_verified {\n  color: #00ba00;\n}\n\n.ststus_cancelled {\n  color: #ff0000;\n}\n\n.refund {\n  padding-left: 10px;\n}\n\n.refund button {\n  padding: 0;\n  background-color: transparent;\n  border: none;\n}\n\n.refund button:hover {\n  background-color: transparent;\n  border: none;\n  box-shadow: none;\n  outline: none;\n}\n\n.refund button:active {\n  background-color: transparent;\n  border: none;\n  box-shadow: none;\n  outline: none;\n}\n\n.refund button:focus {\n  background-color: transparent;\n  border: none;\n  box-shadow: none !important;\n  outline: none;\n}\n\n\n.refund_tooltip {\n  position: relative;\n  display: inline-block;\n  border-bottom: 1px dotted black;\n}\n\n.refund_tooltip .tooltiptext {\n  visibility: hidden;\n  width: 120px;\n  background-color: black;\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding: 5px 0;\n  position: absolute;\n  z-index: 1;\n  // margin-left: 30px;\n}\n\n.refund_tooltip:hover .tooltiptext {\n  visibility: visible;\n}\n\n.search_contain_box {\n  display: flex;\n  gap: 1rem;\n  justify-content: space-between;\n  margin-bottom: 20px;\n  @media screen and (max-width:1240px) {\n    flex-direction: column;\n    align-items: center;\n  }\n}\n.search_contain_box1 {\n  display: flex;\n  gap: 1rem;\n  justify-content: space-between;\n  margin:20px 0;\n}\n.tabbtn{\n  display: flex;\n  gap: 1rem;\n}\n.totalamt{\n  display: flex;\njustify-content: center;\nalign-items: center;\ngap: 10px;\nborder-radius: 5px;\nborder: 1px solid #EAEAEA;\ncolor: var(--Font-black, #0B0D0F);\nfont-size: 18px;\nfont-style: normal;\nfont-weight: 600;\nline-height: normal;\nheight: 42px;\npadding: 10px;\n\n}\n.totalamt span{\n  color: var(--Green, #00C16B);\nfont-size: 18px;\nfont-style: normal;\nfont-weight: 600;\nline-height: normal;\n}\n.totalamt1{\n  display: flex;\njustify-content: center;\nalign-items: center;\ngap: 10px;\nborder-radius: 5px;\nborder: 1px solid #EAEAEA;\ncolor: var(--Font-black, #0B0D0F);\nfont-size: 18px;\nfont-style: normal;\nfont-weight: 600;\nline-height: normal;\nheight: 42px;\npadding: 10px;\n\n}\n.search_contain_box1 h5{\n  margin: 0 !important;\n  padding: 0 !important;\n}\n.totalamt1 ul{\n  list-style: none;\n  display: flex;\n  gap: 10px;\n  padding: 0 !important;\n  margin: 0;\n  \n}\n.totalamt1 span{\ncolor: var(--Primary, #FD9800);\nfont-size: 18px;\nfont-style: normal;\nfont-weight: 600;\nline-height: normal;\n}\n.Total_count {\n  display: flex;\n  gap: 15px;\n  align-items: center;\n  margin-bottom: 20px;\n  margin-right: 15px;\n  justify-content: flex-end;\n}\n\n.Total_seat_count {\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.Total_seat_count span {\n  background: #07bf0d;\n  padding: 5px;\n  border-radius: 3px;\n  color: #fff;\n}\n\n.user_tb_hd {\n  display: flex;\n  gap: 14px;\n  flex-direction: column;\n  justify-content: space-between;\n  @media only screen and (max-width: 767px) {\n    flex-direction: column;\n  }\n  .info_contain {\n    background-color: #D1ECF1;\n    border: solid 1px #BEE5EB;\n    border-radius: 4px;\n    padding: 10px 30px 10px 20px;\n    display: flex;\n    gap: 12px;\n    align-items: center;\n    height: 48px;\n    // width: 100%;\n    @media only screen and (max-width: 767px) {\n      flex-direction: column;\n      height: auto;\n    }\n    @media screen and (min-width:766px) and (max-width:1231px) {\n    border-radius: 4px;\n    padding: 30px 30px 30px 20px;\n    display: flex\n;\n    gap: 12px;\n    align-items: center;\n    height: 45px;\n    }\n    .info_icon {\n\n    }\n    .info_content {\n      display: flex;\n      gap: 12px;\n      @media only screen and (max-width: 767px) {\n        flex-direction: column;\n      }\n      @media screen and (max-width:1231px) {\n        display: flex;\n    gap: 0px;\n    flex-direction: column;\n      }\n    }\n    p {\n      margin: 0px;\n      color: #0C5460;\n      font-size: 16px;\n      font-weight: 500;\n        @media only screen and (max-width: 767px) {\n          text-align: center;\n      }\n    }\n    button {\n      height: unset;\n      background-color: transparent;\n      border: none;\n      padding: 0px;\n      font-size: 16px;\n      font-weight: 700;\n      color: #0C5460;\n      text-decoration: underline;\n      &:hover {\n        color: #1492a7;\n      }\n      &:focus {\n        outline: none;\n        border: none;\n        box-shadow: none;\n      }\n    }\n  }\n}\n\n.sectionright{\n  float: right;\n  display: flex;\n  gap: 30px;\n\n  #dropdown{\n    margin:0px 10px 10px 10px;\n  }\n  #dropdown button{\n      background-color:$primary-btncolor;\n      border-radius:5px;\n      border:none;\n      box-shadow:none;\n      font-size:14px;\n      min-width: 140px;\n      min-height: 44px;\n  }\n  a{\n      font-size:14px;\n       \n  }\n  #del_icon{\n    font-size: 12px;\n    margin-left:5px;\n}\n\n}\n.tdactive{\n  padding: 8px 10px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 100px;\n  margin-top: 8px;\n  background: rgba(0, 193, 107, 0.20);\n  color: #00C16B;\n  text-align: center;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  text-transform: uppercase;\n  margin-top: 8px;\n\n}\n\n.tdinactive{\n  padding: 8px 10px;\njustify-content: center;\nalign-items: center;\nborder-radius: 100px;\nbackground: rgba(255, 0, 0, 0.20);\ncolor: #F00;\ntext-align: center;\nfont-size: 12px;\nfont-style: normal;\nfont-weight: 600;\nline-height: normal;\ntext-transform: uppercase;\nmargin-top: 8px;\n}\n\n.tdyellowbg{\n  padding: 8px 10px;\njustify-content: center;\nalign-items: center;\nborder-radius: 100px;\nbackground: rgba(253, 152, 0, 0.20);\ncolor: #FD9800;\ntext-align: center;\nfont-size: 12px;\nfont-style: normal;\nfont-weight: 600;\nline-height: normal;\ntext-transform: uppercase;\nmargin-top: 8px;\n}\n\n.arrowback{\n  margin-bottom: 0px;\n  cursor: pointer;\n}\n\n.searchcontainer {\n  display:flex;\n  justify-content: end;\n}\n\n.searchcontainer_inner {\n    display: flex;\n    justify-content: end;\n    flex-direction: column;\n}\n\n.attent_flex_contain {\n  display: block;\n}\n\n.attent_flex_contain h5 {\n  margin: 20px 0px;\n}\n\n.pay_btn {\n  margin-right: 10px;\n}\n\n.count_contain {\n  display: flex;\n  flex-direction: column;\n  .totalamt1 {\n    height: auto;\n  }\n}\n\n.userhd{\n  display: flex;\n  justify-content: space-between;\n\n}\n\n@media only screen and (max-width: 1350px) {\n  .searchcontainer_inner {\n    display: unset;\n  }\n}\n\n@media only screen and (max-width: 768px) {\n  .Total_seat_count {\n    font-size: 14px;\n    font-weight: 700;\n  }\n  .search_contain_box {\n  flex-direction: column;\n}\n.search_contain_box1 {\n flex-direction: column;\n}\n.tabbtn{\n  flex-direction: column;\n}\n}\n@media only screen and (max-width: 600px) {\n.totalamt1 ul{\n  flex-direction: column;\n}\n}\n@media only screen and (max-width: 1250px) {\n  \n.search_contain_box1 {\n flex-direction: column;\n}\n}\n\n@media only screen and (max-width: 767px) {\n  .search_contain_box {\n    flex-direction: column;\n    margin-bottom: 20px;\n  }\n  .search_contain_box input {\n    min-width: 100% !important;\n    width: 100% !important;\n  }\n  .search_contain {\n    margin-bottom: 0px;\n  }\n  .Total_count {\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: baseline;\n  }\n  .attent_flex_contain h5 {\n    margin-bottom: 20px;\n  }\n}\n@media only screen and (max-width: 600px) {\n  #dashboardcont2{\n      width: $dashwidth;\n      left: $dashleft;\n      position: relative;\n      padding: $dashboardpadding;\n  }\n  .sectionright {\n    gap: 0;\n    flex-direction: column;\n  }\n}\n tr:nth-child(even){\n  background-color: #fcfcfc;\n} \n\n.onboardsty{\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  justify-content: center;\n}\n\n@media screen and (max-width:1230px) {\n  .onboardsty{\n  display: flex;\n  flex-wrap: wrap;\n  // flex-direction: column;\n  gap: 10px;\n  justify-content: center;\n  align-items: center;\n}\n// .onboardsty button{\n//   width: 100%;\n// }\n.user_tb_hd{\n  flex-direction: column;\n  gap: 10px;\n}\n\n}\n\n\n.count_box_contain {\n  background-color: #fff;\n  border-radius: 5px;\n  padding: 30px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 50px;\n  @media screen and (max-width:767px) {\n      gap: 15px;\n  }\n  ul {\n    padding: 0px;\n    margin: 0px;\n    display: flex;\n    gap: 10px;\n    @media screen and (max-width: 767px) {\n      flex-wrap: wrap;\n    }\n    @media screen and (max-width:420px) {\n    padding: 0px;\n    margin: 0px;\n    display: flex;\n    justify-content: space-between;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n\n    }\n    li {\n      list-style: none;\n      display: flex;\n      flex-direction: column;\n      gap: 20px;\n      width: 20%;\n       @media screen and (min-width: 576px) and (max-width: 767px) {\n        width: 33% !important;\n      }\n       @media screen and (min-width: 420px) and (max-width:576px){\n        width: 45% !important;\n      }\n      @media screen and(max-width:420px) {\n    list-style: none;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    width: 100% !important;\n    justify-content: center;\nalign-items: center;\n}\n      .count_text {\n        font-size: 16px;\n        font-weight: 600;\n        color: #727272;\n        @media screen and (max-width:998px) {\n          font-size: 14px !important;\n        }\n        @media screen and (max-width:1244px) {\n          font-size: 12px;\n        }\n      }\n      .count_num {\n        font-size: 22px;\n        font-weight: 700;\n        color: #131F43;\n         @media screen and (max-width:998px) {\n          font-size: 18px !important;\n        }\n        @media screen and (max-width:1244px) {\n          font-size: 16px;\n        }\n      }\n    }\n  }\n}\n\n.export_btn {\n  font-size: 16px;\n  font-weight: 600;\n  color: #131F43;\n  border: solid 1px #131F43;\n  border-radius: 5px;\n  background-color: transparent !important;\n  display: flex;\n  gap: 10px;\n  border-color: #131F43 !important;\n}\n\n.export_btn svg {\n  fill: #131F43;\n}\n\n\n.export_btn:hover {\n  color: #fff;\n  border: solid 1px #131F43;\n  background-color: #131F43 !important;\n}\n\n.export_btn:hover svg {\n  fill: #fff;\n}\n\n.table_attendee {\n  th{\n    @media screen and (max-width:1200px) {\n      min-width: auto;\n    }\n    @media screen and (max-width:767px) {\n      min-width: 150px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `AttendeeCustomTable_dashboard__ar5py`,
	"dashboardContain": `AttendeeCustomTable_dashboardContain__9Ea-6`,
	"bodythemedark": `AttendeeCustomTable_bodythemedark__aBYIU`,
	"cont2": `AttendeeCustomTable_cont2__vnuPv`,
	"top_header": `AttendeeCustomTable_top_header__fPV4a`,
	"top_header_inner": `AttendeeCustomTable_top_header_inner__7ErW4`,
	"subLink": `AttendeeCustomTable_subLink__zGuKZ`,
	"cst_vendr": `AttendeeCustomTable_cst_vendr__odxfK`,
	"form-control": `AttendeeCustomTable_form-control__zbaGf`,
	"footer": `AttendeeCustomTable_footer__2XRLu`,
	"bodythemelight": `AttendeeCustomTable_bodythemelight__Fycx+`,
	"bodythemeNew": `AttendeeCustomTable_bodythemeNew__IaYc1`,
	"headerthemelight": `AttendeeCustomTable_headerthemelight__Eyjk7`,
	"headerthemedark": `AttendeeCustomTable_headerthemedark__rrIXM`,
	"menuthemelight": `AttendeeCustomTable_menuthemelight__wQ+6e`,
	"menuthemedark": `AttendeeCustomTable_menuthemedark__+bzgb`,
	"menulinklight": `AttendeeCustomTable_menulinklight__g7BfP`,
	"menulinkdarkSelected": `AttendeeCustomTable_menulinkdarkSelected__tRIFG`,
	"menulinklightSelected": `AttendeeCustomTable_menulinklightSelected__UnJpq`,
	"menulinkdark": `AttendeeCustomTable_menulinkdark__+srHQ`,
	"sub_arrow": `AttendeeCustomTable_sub_arrow__h6ARI`,
	"headinglight": `AttendeeCustomTable_headinglight__2yuFe`,
	"headingdark": `AttendeeCustomTable_headingdark__ghMSk`,
	"searchboxlight": `AttendeeCustomTable_searchboxlight__T8h28`,
	"searchboxdark": `AttendeeCustomTable_searchboxdark__Fc-G5`,
	"tableheadlight": `AttendeeCustomTable_tableheadlight__KxfZg`,
	"tableheaddark": `AttendeeCustomTable_tableheaddark__wIhca`,
	"table": `AttendeeCustomTable_table__5S-F2`,
	"table-borderless": `AttendeeCustomTable_table-borderless__2mPFq`,
	"left-section": `AttendeeCustomTable_left-section__oyvL0`,
	"tablebodylight": `AttendeeCustomTable_tablebodylight__pdgcp`,
	"tablebodydark": `AttendeeCustomTable_tablebodydark__qAncM`,
	"paginationlight": `AttendeeCustomTable_paginationlight__40Aii`,
	"paginationdark": `AttendeeCustomTable_paginationdark__4R6bb`,
	"formthemelight": `AttendeeCustomTable_formthemelight__TKLpc`,
	"formthemedark": `AttendeeCustomTable_formthemedark__lm8-U`,
	"viewformlight": `AttendeeCustomTable_viewformlight__evfnU`,
	"permissionboxlight": `AttendeeCustomTable_permissionboxlight__hZBAe`,
	"permissionboxdark": `AttendeeCustomTable_permissionboxdark__B9ap7`,
	"errormsgclr": `AttendeeCustomTable_errormsgclr__fHGm5`,
	"graphclrlight": `AttendeeCustomTable_graphclrlight__f3TwN`,
	"graphclrdark": `AttendeeCustomTable_graphclrdark__C5z2h`,
	"card1bglight": `AttendeeCustomTable_card1bglight__9LW9u`,
	"card1bgdark": `AttendeeCustomTable_card1bgdark__dRgRB`,
	"card2bglight": `AttendeeCustomTable_card2bglight__34AQ0`,
	"card2bgdark": `AttendeeCustomTable_card2bgdark__kSbyi`,
	"card3bglight": `AttendeeCustomTable_card3bglight__20AQ5`,
	"card3bgdark": `AttendeeCustomTable_card3bgdark__PvhS2`,
	"card4bglight": `AttendeeCustomTable_card4bglight__iBmgK`,
	"card4bgdark": `AttendeeCustomTable_card4bgdark__A-nK2`,
	"actionbtnlight": `AttendeeCustomTable_actionbtnlight__oVVbZ`,
	"actionbtndark": `AttendeeCustomTable_actionbtndark__b6SuU`,
	"profiledropdownlight": `AttendeeCustomTable_profiledropdownlight__Esary`,
	"profiledropdowndark": `AttendeeCustomTable_profiledropdowndark__ZKBNt`,
	"settingsection": `AttendeeCustomTable_settingsection__Bfq+v`,
	"addform": `AttendeeCustomTable_addform__SXsM9`,
	"savebtn": `AttendeeCustomTable_savebtn__6wLWt`,
	"profile_conatiner": `AttendeeCustomTable_profile_conatiner__KnlOE`,
	"ag-theme-alpine": `AttendeeCustomTable_ag-theme-alpine__ZXAFI`,
	"ag-row": `AttendeeCustomTable_ag-row__OHnLq`,
	"formbtn": `AttendeeCustomTable_formbtn__aCSGq`,
	"resetbtn": `AttendeeCustomTable_resetbtn__ljCy-`,
	"addBtn": `AttendeeCustomTable_addBtn__YJnoY`,
	"addDltBtn": `AttendeeCustomTable_addDltBtn__7aHOO`,
	"addbtnlight": `AttendeeCustomTable_addbtnlight__948dV`,
	"addbtndark": `AttendeeCustomTable_addbtndark__26l-y`,
	"cust_addBtn": `AttendeeCustomTable_cust_addBtn__rVSnr`,
	"deleteBtn": `AttendeeCustomTable_deleteBtn__KsvX9`,
	"confirmBtn": `AttendeeCustomTable_confirmBtn__P+GTu`,
	"delPopContainer": `AttendeeCustomTable_delPopContainer__xhcoA`,
	"modal-body": `AttendeeCustomTable_modal-body__Cz2Ep`,
	"delet_icon": `AttendeeCustomTable_delet_icon__P4-5Z`,
	"arrowback": `AttendeeCustomTable_arrowback__jXmv0`,
	"drpdwn_btn": `AttendeeCustomTable_drpdwn_btn__0xF-4`,
	"empname": `AttendeeCustomTable_empname__+7jN8`,
	"navitemli": `AttendeeCustomTable_navitemli__TqhdC`,
	"tabnavli": `AttendeeCustomTable_tabnavli__b7GqZ`,
	"settingsgeneral": `AttendeeCustomTable_settingsgeneral__SwlNi`,
	"settingslinks": `AttendeeCustomTable_settingslinks__Ag6yJ`,
	"dropdown_menu_contain": `AttendeeCustomTable_dropdown_menu_contain__0x2Mm`,
	"dropdown_item": `AttendeeCustomTable_dropdown_item__ePkjb`,
	"profile_arrrow_dwn": `AttendeeCustomTable_profile_arrrow_dwn__X24e-`,
	"dateinputbox1": `AttendeeCustomTable_dateinputbox1__H9kdw`,
	"modal-content": `AttendeeCustomTable_modal-content__J1sSs`,
	"larg_model": `AttendeeCustomTable_larg_model__UJOhp`,
	"modal-dialog": `AttendeeCustomTable_modal-dialog__lQ247`,
	"modal-header": `AttendeeCustomTable_modal-header__yQJ5J`,
	"btn-primary": `AttendeeCustomTable_btn-primary__7phB5`,
	"form-select": `AttendeeCustomTable_form-select__b+156`,
	"CustomTable_tableheadlight__HuHZw": `AttendeeCustomTable_CustomTable_tableheadlight__HuHZw__INszt`,
	"CustomTable_tableheaddark__nwqb4": `AttendeeCustomTable_CustomTable_tableheaddark__nwqb4__Ydh-G`,
	"sectionright": `AttendeeCustomTable_sectionright__VsLJr`,
	"exer_modal_contain": `AttendeeCustomTable_exer_modal_contain__OBVAt`,
	"active_show_outer": `AttendeeCustomTable_active_show_outer__8xIOk`,
	"active_show_inner": `AttendeeCustomTable_active_show_inner__0XBsl`,
	"act_box_img": `AttendeeCustomTable_act_box_img__HmdoN`,
	"act_box_cnt": `AttendeeCustomTable_act_box_cnt__CO0Vi`,
	"act_box_bdg": `AttendeeCustomTable_act_box_bdg__RyeZr`,
	"sold": `AttendeeCustomTable_sold__yDKjh`,
	"timezone_code_pill": `AttendeeCustomTable_timezone_code_pill__Xv1ut`,
	"attent_details_row1": `AttendeeCustomTable_attent_details_row1__QzaqR`,
	"attent_details": `AttendeeCustomTable_attent_details__UE-T8`,
	"attent_details_inner": `AttendeeCustomTable_attent_details_inner__+5muo`,
	"attent_details_inner_l": `AttendeeCustomTable_attent_details_inner_l__s4ZJ1`,
	"attent_details_inner_r": `AttendeeCustomTable_attent_details_inner_r__VBJS6`,
	"attent_details_row": `AttendeeCustomTable_attent_details_row__MRKC7`,
	"attent_details_row_box": `AttendeeCustomTable_attent_details_row_box__Dcn+4`,
	"attent_details_row_last": `AttendeeCustomTable_attent_details_row_last__2pV44`,
	"interesting_fact": `AttendeeCustomTable_interesting_fact__hV+i6`,
	"showbox_sec": `AttendeeCustomTable_showbox_sec__YPor7`,
	"show_box_main": `AttendeeCustomTable_show_box_main__3PUud`,
	"show_box": `AttendeeCustomTable_show_box__ZKqsy`,
	"no_show_box": `AttendeeCustomTable_no_show_box__gI-I1`,
	"attent_flex": `AttendeeCustomTable_attent_flex__LuDTd`,
	"container": `AttendeeCustomTable_container__xcoZC`,
	"tableheading": `AttendeeCustomTable_tableheading__GyDGF`,
	"search_box": `AttendeeCustomTable_search_box__QlVKg`,
	"spinner": `AttendeeCustomTable_spinner__P97Nm`,
	"tbl_sl": `AttendeeCustomTable_tbl_sl__Sghd-`,
	"tablebtn": `AttendeeCustomTable_tablebtn__GB0Ut`,
	"tableheaddiv": `AttendeeCustomTable_tableheaddiv__teRA8`,
	"sortbtn": `AttendeeCustomTable_sortbtn__47Ecs`,
	"order_date": `AttendeeCustomTable_order_date__mmWt7`,
	"norecord": `AttendeeCustomTable_norecord__AfH9d`,
	"norecordsdiv": `AttendeeCustomTable_norecordsdiv__1+bE+`,
	"ststus_text": `AttendeeCustomTable_ststus_text__gewaA`,
	"ststus_not_verified": `AttendeeCustomTable_ststus_not_verified__9EDWK`,
	"ststus_verified": `AttendeeCustomTable_ststus_verified__Xn1oa`,
	"ststus_cancelled": `AttendeeCustomTable_ststus_cancelled__Ywp6j`,
	"refund": `AttendeeCustomTable_refund__-dSx6`,
	"refund_tooltip": `AttendeeCustomTable_refund_tooltip__Bg-mU`,
	"tooltiptext": `AttendeeCustomTable_tooltiptext__r6xdz`,
	"search_contain_box": `AttendeeCustomTable_search_contain_box__OcQ1e`,
	"search_contain_box1": `AttendeeCustomTable_search_contain_box1__DdZQY`,
	"tabbtn": `AttendeeCustomTable_tabbtn__2KYu+`,
	"totalamt": `AttendeeCustomTable_totalamt__LT2p4`,
	"totalamt1": `AttendeeCustomTable_totalamt1__Jpdbh`,
	"Total_count": `AttendeeCustomTable_Total_count__KQSZL`,
	"Total_seat_count": `AttendeeCustomTable_Total_seat_count__z-M-N`,
	"user_tb_hd": `AttendeeCustomTable_user_tb_hd__avwA4`,
	"info_contain": `AttendeeCustomTable_info_contain__Me548`,
	"info_content": `AttendeeCustomTable_info_content__HN7om`,
	"dropdown": `AttendeeCustomTable_dropdown__8ExS4`,
	"del_icon": `AttendeeCustomTable_del_icon__oWLMh`,
	"tdactive": `AttendeeCustomTable_tdactive__Q9CO8`,
	"tdinactive": `AttendeeCustomTable_tdinactive__0HIXZ`,
	"tdyellowbg": `AttendeeCustomTable_tdyellowbg__PbpMV`,
	"searchcontainer": `AttendeeCustomTable_searchcontainer__mlndk`,
	"searchcontainer_inner": `AttendeeCustomTable_searchcontainer_inner__-CWtR`,
	"attent_flex_contain": `AttendeeCustomTable_attent_flex_contain__q1YYz`,
	"pay_btn": `AttendeeCustomTable_pay_btn__SUh-t`,
	"count_contain": `AttendeeCustomTable_count_contain__JIQHT`,
	"userhd": `AttendeeCustomTable_userhd__nkc+J`,
	"search_contain": `AttendeeCustomTable_search_contain__hxCOj`,
	"dashboardcont2": `AttendeeCustomTable_dashboardcont2__fOe6q`,
	"onboardsty": `AttendeeCustomTable_onboardsty__v6x7b`,
	"count_box_contain": `AttendeeCustomTable_count_box_contain__OTD6y`,
	"count_text": `AttendeeCustomTable_count_text__chW1-`,
	"count_num": `AttendeeCustomTable_count_num__IA57o`,
	"export_btn": `AttendeeCustomTable_export_btn__05vaH`,
	"table_attendee": `AttendeeCustomTable_table_attendee__qMqyb`
};
export default ___CSS_LOADER_EXPORT___;
